export default class Dict {

    getDict = (lang) => {

        if (lang === 'ro') {
            return this.dictRO;
        }
        else if (lang === 'en') {
            return this.dictENG;
        }
        else
            return this.dictRO; // default

    }


    dictRO = {


        appBar: {
            drawer: {
                home: 'Acasa',
                projectsManagement: 'Management de Proiecte',
                projects: 'Proiecte',
                economic: 'Economic',
                documentsManagement: 'Management Documente',
                monitorizareaAngajatilor: 'Monitorizarea Angajatilor',
                financial: 'Diagnostic Financiar',
                pontaj: 'Pontaj',
                evaluations: 'Evaluari',
                colegueEvaluations: 'Evaluarea de catre colegi',
                questionariesEvaluations: 'Evaluari Chestionare',
                managementEvaluations: 'Evaluarea angajatilor de catre sefi',
                generalEvaluation: 'Evaluare Generala',
                clientsEvaluations: 'Evaluarea angajatilor de catre clienti',
                administrare: 'Administrare',
                userManagement: 'Administrarea Utilizatorilor',
                departmentManagement: 'Administrarea Departamentelor',
                logout: 'Log Out',
                setari: 'Setari',
                resurseUmane: 'Resurse Umane',
                rapoarte: 'Rapoarte',
                ticheteDeMasa: 'Tichete de Masa',
                documenteHR: 'Documente',
                candidati: 'Candidati',
                operatiuni: 'Operatiuni',
                raportareMonitorizare: 'Raportare',
                managementBilanturi: 'Management Bilanturi',
                timpLucru:'Timp de Lucru',
                monitorizare:'Monitorizare',
                evaluareFinanciara:"Evaluare Financiara",
                evaluareaActivitatiiAngajatilor:'Evaluarea Activitatii Angajatilor',
                selectiePersonal:'Selectie Personal'

            },


            buttons: {
                inapoi: 'Inapoi',
                insertUser: 'Adauga Utilizator',

            }
        },

        home: {
            controlPanel: 'Panou de control',
            mesajPanouControl:'Pentru actiuni va rugam dati click pe butonul din stanga sus.',
            limba:'Limba',
            downloadAplicatie:'Pentru a downloada aplicatia desktop sau aplicatia de monitorizare va rugam apasati pe butoanele de mai jos.',
            downloadApp:'Download Aplicatie',
            downloadMonitorizare:'Download Aplicatie Monitorizare'

        },

        login: {
            user: 'Email',
            password: 'Parola',
            or: 'Sau',
            signUp: 'Autentifca-te',
            logIn: 'Log In',
            repeatPass: 'Repeta Parola',
            passWarn: 'Parolele nu sunt la fel',
            userWarn: 'Emailul nu este corect',
            societyName: 'Nume Societate',
            cui: 'CUI',
            userName: 'Nume Utilizator',
            repeatPassword: 'Repeta Parola',
            wantToLogIn: 'Vrei sa te loghezi ? ',
            clickHere: 'Click aici',
            noAccount: 'Nu ai cont ?',
            parolaGresita:`Ai incercat sa te loghezi de 10 ori fara succes, accesul tau a fost blocat pentru 15 minute.`
        },

        comune: {
            add: 'Adauga',
            save: 'Salveaza',
            detailsView: 'Detalii',
            search: 'Cauta',
            edit: 'Editeaza',
            theme: 'Tema',
            yes: 'Da',
            no: 'Nu',
            ok: 'Ok',
            sterge: 'Sterge',
            adaugaProgramCompanie:'Adauga Program Companie'
        },

        settings: {
            title: "Setari",
            nume: 'Nume',
            email: 'Email',
            telefon: 'Telefon',
            accessProjects: 'Acces Proiecte',
            createProjects: 'Creeaza Proiecte',
            modifyEmployees: 'Modifica Angajati',
            deactivateAccount: 'Dezactiveaza Cont',
            alertDeactivate: 'Sunteti sigur ca vreti sa dezactivati contul ?',
            isAdmin: 'Admin',
            doarCitire: 'Doar Citire',
            drepturiExtinse: 'Drepturi Extinse',
            valoare: 'Valoare',
            dataCost: 'Data Cost',
            note: 'Note',
            explicatii: 'Explicatii',
            responsabil: 'Nivel Responsabil',
            veziProiecte: 'Vezi Proiecte',
            tipDocument: 'Doc pentru'
        },
        evaluari: {

            denumireRaport:'Denumire Raport',
            afisarePentru:'Afisare Pentru',
            rezultatePentru:'Rezultate Pentru',

            alertStergeSesiune: 'Doresti sa stergi sesiunea selectata ?',
            alertStergeSesiuneMessage: 'Atentie ! Sesiunea odata stearsa nu mai poate fi recuperata. ',
            evaluareColegi: 'Evaluare de catre Colegi ',
            creeazaDenumireEvaluare: 'Creeaza o denumire pentru aceasta sesiune de evaluare.',
            numeSesiune: 'Nume Sesiune',
            pasulUrmator: 'Pasul Urmator',
            nuExistaSesiuneColegi: 'Nu exista nici o sesiune de evaluare activa a personalului de catre colegi. Initiaza o evaluare noua apasand butonul de mai jos',
            sesiuneNoua: 'Sesiune Noua',
            sesiuneEvaluare: 'Sesiunea de Evaluare',
            completare: 'COMPLETARE',
            finalizat: 'FINALIZAT',
            nuAiChestionarSalvatSistem: 'Evaluarile Total Suite se bazeaza pe chestionare. Am observat ca nu ai nici un chestionar de evaluare salvat in sistem',
            clickAici: 'Click Aici',
            pentruACreaUnChestionarAcum: 'pentru a crea acum un chestionar.',
            astazi: 'Astazi',
            evaluareClienti: 'Evaluare de catre Clienti',
            nuExistaSesiuneClienti: 'Nu exista nici o sesiune de evaluare activa a personalului de catre clienti. Initiaza o evaluare noua apasand butonul de mai jos',
            evaluareManager: 'Evaluare de catre Manager',
            nuExistaSesiuneManageri: 'Nu exista nici o sesiune de evaluare activa a personalului de catre manager. Initiaza o evaluare noua apasand butonul de mai jos',
            alertStergeEvaluare: 'Doresti sa stergi evaluarea selectata ?',
            alertStergeEvaluareMessage: 'Atentie ! Evaluarea odata stersa nu mai poate fi recuperata. ',
            alertStergeRaport: 'Doresti sa stergi raportul selectat ?',
            alertStergeRaportMessage: 'Atentie ! Raportul odata sters nu mai poate fi recuperat. ',
            evaluareGenerala: 'Evaluare Generala',
            titluSesiuneGenerala: 'Titlu Sesiune Generala',
            sesiuneGenerala: 'Sesiune Generala',
            titluSesiuneColegi: 'Titlu Sesiune Colegi',
            sesiuneColegi: 'Sesiune Colegi',
            titluSesiuneManager: 'Titlu Sesiune Manager',
            sesiuneManager: 'Sesiune Manager',
            titluSesiuneClienti: 'Titlu Sesiune Clienti',
            sesiuneClienti: 'Sesiune Clienti',
            creeaza: 'Creeaza',
            selecteazaSauCreeaza: 'Selecteaza una din sesiunile de evaluare de mai jos sau creaza o sesiune noua',
            mesajCreeazaEvaluareGenerala: `Esti pe cale sa initiezi o sesiune generala de evaluare. Aceasta evaluare contine toate cele 3 tipuri de evaluari posibile in Total Suite, si anume Evaluarea de catre Colegi, Evaluarea de catre Manager
            si Evaluarea de catre Clienti. Aceste Evaluari se vor regasi si in sectiunile lor individuale dar vor fi centralizate aici. Iti recomandam crearea unui formular special pentru acest tip de evaluare. Afla mai multe despre Formularul de evaluare Generala`,
            aici: 'aici',
            alegeOptiune: 'Alege o optiune',
            sesiuneGeneralaNoua: 'Sesiune Generala Noua',
            inapoi: 'Inapoi',
            nuExistaSesiuneGenerala: 'Nu exista nici o sesiune de evaluare generala activa. Initiaza o evaluare noua apasand butonul de mai jos',
            combinaEvaluariExistente: 'Combina Evaluari Existente',
            creeazaRaportGeneral: 'Creeaza un raport General',
            scorTotal: 'SCOR TOTAL',
            veziRaport: 'Vezi Raport',
            departament: 'Departament',
            data: 'Data',
            evaluatori: 'Evaluatori',
            completareNoCaps: 'Completare',
            puncte: 'Puncte',
            finalizeazaSesiunea: 'Finalizeaza Sesiunea',
            sesiuneChestionareDiferite: 'Sesiunile individuale de evaluare din aceasta sesiune generala sunt construite pe chestionare diferite. Din acest motiv raportul general se construieste doar in functie de scorurile sesiunilor respective.',
            rapoarteSalvate: 'Rapoarte Salvate',
            evaluareNoua: 'Evaluare noua',
            sesiunea: 'Sesiunea',
            finalizatNoCaps: 'Finalizat',
            persoaneRaport: 'Selecteaza persoanele sau departamentele care doresti sa fie incluse in raport si apasa butonul Creaza Raport',
            creeazaRaport: 'Creeaza Raport',
            peCineEvaluezi: 'Pe cine doresti sa evaluezi ?',
            selecteaza: 'Selecteaza',
            alegeDepartament: 'Alege departamentul',
            formularEvaluare: 'Formular de evaluare',
            alegeFormular: 'Alege formular',
            administrareFormulare: 'pentru administrare formulare',
            creeazaEvaluarea: 'Creeaza evaluarea',
            selecteazaEvaluatori: 'Selecteaza Evaluatori',
            evaluatoriAlgoritm: 'Evaluatori pentru fiecare persoana evaluata dupa urmatorul algoritm',
            persoaneAcelasiDepartament: 'pers. din acelasi departament ',
            persoaneLaIntamplare: 'pers. alese la intamplare astfel incat sa acopere cat mai multe departamente ',
            dateAngajat: 'Date despre angajat',
            numeAngajat: 'Nume',
            functieAngajat: 'Functie',
            colegiInDept: 'Colegi in dept',
            dateDepartament: 'Date despre departament',
            angajati: 'Angajati',
            utlimaEvaluare: 'Ultima Evaluare',
            dataUltimaEvaluare: 'Data ultimei evaluari',
            nrEvaluatori: 'Nr. Evaluatori',
            din: 'din',
            evaluatoriSelectati: 'evaluatori selectati',
            selecteazaSauAdaugaClienti: 'Selecteaza sau adauga clienti',
            selecteazaSauAdaugaClientiMessage: 'Selecteaza Clientii ce vor evalua anagajatul din lista de mai jos sau adauga manual Numele si Adresa de e-mail. Asigura-te ca selectezi sau adaugi clienti care au lucrat in realitate cu acest angajat.',
            clientiSelectati: 'Clienti Selectati',
            clientiEvaluatoriAdaugati: 'Clienti Evaluatori Adaugati',
            adaugaManualClienti: 'Adauga manual clienti',
            numeSiPrenume: 'Nume si Prenume',
            adresaEmail: 'Adresa E-mail',
            selecteazaClientiExistenti: 'Selecteaza Clienti Existenti',
            adaugaClientiSelectati: 'Adauga clientii selectati',
            salveazaSiInchide: 'Salveaza si inchide',
            mesajEvaluareClienti: ` Esti pe cale sa initiezi o sesiune de evaluare pentru mai mult de o persoana. In urmatorii pasi trebuie sa declari un numar de maxim 10 clienti pentru fiecare persoana evaluata.
            Adauga sau selecteaza clienti care au lucrat cu persoanele respective. Apasa butonul verde Creeaza Evaluarea pentru a incepe procesul.`,
            urmatorulEvaluat: 'Urmatorul Evaluat',
            selecteazaClienti: 'Selecteaza Clienti',
            tipEvaluareClientiMesaj: 'Pentru acest tip de evaluare trebuie sa adaugi sau sa selectezi maxim 10 Clienti ce au lucrat cu aceasta persoana. Apasa butonul de mai jos pentru a incepe ',
            adaugaClienti: 'Adauga Clienti',
            administrareClienti: 'Administrare Clienti',
            din10Evaluatori: 'din 10 Clienti Evaluatori Adaugati',
            initiazaEvaluarea: 'Initiaza evaluarea',
            selecteazaManageriEvaluatori: 'Selecteaza Manageri Evaluatori',
            selecteazaClientiEvaluatori: 'Selecteaza Clienti Evaluatori ',
            lucratoriDepartament: 'Lucratori Departament',
            lucratoriCompanie: 'Lucratori Companie',
            conditiiIndeplinite: 'Toate conditiile sunt indeplinite! ',
            conditiiIndepliniteMesaj: 'Felicitari! Toate conditiile pentru a demara Sesiunea Generala de Evaluare sunt indeplinite. In acest moment poti modifica alegerile tale pentru fiecare angajat apasand pe numele sau.',
            apasaButonulVerde: 'Apasa butonul verde',
            initiazaEvaluareaPentruADemara: 'Initiaza Evaluarea pentru a demara aceasta sesiune',

        },


        pontaje: {
            nrZileConcediu:'Nr. Zile Concediu',
            angajatiDemisionati:'Angajati Demisionati',
            evaluareColegi:'Evaluare de Catre Colegi', 
            evaluareManager:'Evaluare de Catre Manager', 
            evaluareClienti:'Evaluare de catre Clienti',
            evaluareGenerala:'Evaluare Generala',
            dataGenerarii:'Data Generarii',
            

            prezentProgramNormal:'Prezent - program normal',
            prezent:'Prezent',
            absentaNemotivata:'Absenta Nemotivata',
            absentaInvoire:'Absenta Invoire',
            invoireFaraAbsenta:'Invoire(Fara Absenta)',
            oreSuplimentare:'Ore Suplimentare',
            cFaraPlata:'C. Fara Plata',
            cOdihna:'C. Odihna',
            cMedical:'C. Medical',
            cMedicalAccident:'C. Medical Accident, Boala Profesionala, Carantina',
            cMaternitate:'C. Maternitate, Paternitate, Crestere Copil, Ingrijire Copil',
            cEvenimenteSpeciale:'C. Evenimente Deosebite',
            cAcomodare:'C. Acomodare, C. Preaviz',
            operatiuniCandidati:'Operatiuni Candidati',
            rapoarte:'Rapoarte',
            nuExistaProgram:`Utilizatorul nu are un program definit in aceasta zi .`,
            vaRugamAdaugatiProgram:'Va rugam adaugati un program pentru acest utilizator.',
            resurseUmane: 'Resurse Umane',
            calendarPontaj: 'Calendar Pontaj',
            legenda: 'Legenda',
            toate: 'Toate',
            departamentCautaLucrator: 'Departament / Cauta Lucrator',
            functie: 'Functie',
            departament: 'Departament',
            zileConcediuRamase: 'Zile de Concediu Ramase',
            evenimenteAnulCurent: 'Evenimente in Anul Curent',
            adaugaEvenimentNou: 'Adauga un Eveniment Nou',
            dataInceput: 'Data inceput',
            dataSfarsit: 'Data Sfarsit',
            tipEveniment: 'Tip de Eveniment',
            adaugaEvenimentul: 'Adauga Evenimentul',
            dataEveniment: 'Data Eveniment',
            oraIncepere: 'Ora Incepere',
            oraFinalizare: 'Ora Finalizare',
            operatiuniResurseUmane: 'Operatiuni Resurse Umane',
            dataAngajarii: 'Data Angajarii',
            incadrareSalariala: 'Incadrare Salariala',
            ticheteDeMasa: 'Tichete de Masa',
            operatiuni: 'Operatiuni',
            candidati: 'Candidati',
            angajareNoua: 'Angajare Noua',
            dataInterviu: 'Data Interviu',
            specializari: 'Specializari',
            candidat: 'Candidat',
            candidatNou: 'Candidat Nou',
            status: 'Status',
            dateCompanie: 'Date Companie',
            email: 'Email',
            nrTelefon: 'Nr. Telefon',
            oras: 'Oras',
            adresa: 'Adresa',
            permis: 'Permis Conducere',
            editeaza: 'Editeaza',
            demisieConcediere: 'Demisie/Concediere',
            incadrare: 'Incadrare',
            programLucru: 'Program de Lucru',
            balantaConcediu: 'Balanta Zile de Concediu',
            concediu: 'Concediu',
            odihna: 'Odihna',
            zile: 'Zile',
            medical: 'Medical',
            zileSpeciale: 'Zile Speciale',
            alteConcedii: 'Alte tipuri de',
            zileConcediu: 'Zile Concediu',
            ramase: 'Ramase',
            evaluari: 'Evaluari',
            data: 'Data',
            evaluatori: 'Evaluatori',
            completare: 'Completare',
            punctaj: 'Punctaj',
            angajeaza: 'Angajeaza',
            datePersonale: 'Date Personale',
            dateAngajare: 'Date Angajare',
            nume: 'Nume',
            numeFamilie: 'Nume Familie',
            adresaResedinta: 'Adresa Resedinta',
            categoriePermis: 'Categorie Permis',
            salariulPropus: 'Salariul Propus',
            specializare: 'Specializare',
            documenteCandidat: 'Documente Candidat',
            cv: 'CV',
            alteDocumente: 'Alte Documente',
            generazaDocumenteAngajare: 'Genereaza Documente Angajare',
            dataNastere: 'Data Nastere',
            dateIdentificare: 'Date Identificare',
            cnp: 'CNP',
            serieCi: 'Serie CI',
            dateContact: 'Date Contact',
            salarizare: 'Salarizare',
            salariuBrut: 'Salariu Brut',
            salariuLunarNet: 'Salariu Lunar Net',
            documenteAngajare: 'Documente Angajare',
            documenteResurseUmane: 'Documente Resurse Umane',
            cauta: 'Cauta',
            fisiere: 'Fisiere',
            documenteEditabile: 'Documente Editabile',
            documentePdf: 'Documente PDF',
            documenteJpg: 'Documente JPG',
            rezultateCautare: 'Rezultate Cautare',
            inapoi: 'Inapoi',
            creatLa: 'Creat pe',
            documenteHrInEvidenta: 'Documente HR in Evidenta',
            documentNou: 'Document Nou',
            programLucru:'Program Lucru',
            adaugaProgram:'Adauga Program',
            monitorizareLive:'Monitorizare Live',
            data:'Data',
            status:'Status',
            inactivAzi:'Inactiv Azi',
            candActiv:'Ultima Ora Activ',
            raportareIndividuala:'Raportare Individiuala',
            raportAngajat:'Raport Angajat',
            foaieColectiva:'Foaie Colectiva',
            templateuri:'Templateuri',
            adaugaDocument:'Adauga Document',
            creeazaDocument:'Creeaza Document',
            foaieColectiva:'Foaie Colectiva',
            inapoiLaPontaj:'Inapoi la pontaj',
            salveaza:'Salveaza'

        },


        monitorizare: {
            esteProductiva:'Este Productiva',
            salveaza:'Salveaza',
            sterge:'Sterge',
            numeleProcesului:'Numele Procesului',
            numeleProcesului32:'Numele Procesului 32Bits',
            aplicatie:'Aplicatie',
            numeAplicatie:'Nume Aplicatie',
            adaugaAplicatie:'Adauga Aplicatie',
            monitorizareAngajati: 'Monitorizare Angajati',
            statusul: 'Statusul',
            scor: 'Scor',
            celeMaiFolosite: 'Cele mai folosite',
            statut: 'Status',
            departament: 'Departament',
            celeMaiFolosite: 'Cele mai folosite',
            lucratori: 'Lucratori',
            appProductivitate: 'Aplicatii Productive',
            appNeproductivitate: 'Aplicatii Neproductive',
            oraPornire: 'Ora Pornire',
            timpProductiv: 'Timp Productiv',
            productivitate: 'Productivitate',
            distributiaTimpului: 'Distributia Timpului',
            timpNeproductiv: 'Timp Neproductiv',
            timpMort: 'Timp Mort',
            aplicatiiProductive: 'Aplicatii Productive',
            aplicatiiNeproductive: 'Aplicatii Neproductive',
            screenshots: 'Capturi de ecran',
            baraProductivitate: 'Bara de Productivitate',
            folosireAplicatie: 'Folosire Aplicatie',
            denumire: 'Denumire',
            timp: 'Timp',
            raportareMonitorizareAngajati: 'Raportare Monitorizare Angajati',
            raportLunar: 'Raport Lunar',
            zileLucrate: 'Zile Lucrate',
            totalOre: 'Total Ore',
            prodMedie: 'Prod. Medie',
            scorMediu: 'Scor Mediu',
            distributiaTimpului: 'Distributia Timpului',
            pauza: 'Pauza',
            dataStart:'Data Start',
            dataSfarsit:'Data Sfarsit',
            afisazaRaport:'Afiseaza Raport',
            aplicatii:'Aplicatii',
            ora:'Ora',
            eticheta:'Eticheta',
            eticheteFolosite:'Etichete Folosite',
            totalLucrat:'Total Lucrat',
            nuExistaDatePentruOra:'Nu sunt date inregistrate pentru aceasta ora !'


        },


        financiar: {
            bilanturi: 'Bilanturi',
            bilanturiInregistrateInSistem: 'Bilanturi inregistrate in sistem',
            bilantFinanciar: 'Bilant Financiar',
            tipBilant: 'Tip Bilant',
            tipEntitate: 'Tip Entitate',
            cifraDeAfaceri: 'Cifra de Afaceri',
            clienti: 'Clienti',
            adaugaBilantNou: 'Adauga Bilant Nou',
            inapoi: 'Inapoi',
            bilanturiLength0: 'Momentan nu ai nici un bilant introdus in sistem. Pentru a alimenta sectiunea Diagnostic Financiar ai nevoie de unul, ideal mai multe bilanturi. Apasa butonul de mai jos pentru a introduce un bilant nou in sistemul Total Works. ',
            informatiiBilant: 'Informatii despre acest bilant',
            tipBilant: 'Tip Bilant',
            an: 'An',
            denumire: 'Denumire',
            tipEntitate: 'Tip Entitate',
            bilantNouMesaj: 'Esti pe cale sa initiezi o sesiune de introducere de date din bilantul tau contabil. Completeaza datele de mai sus si apasa butonul salveaza. Procesul te va trece prin mai multi pasi in care vei primi instructiuni de introducere a valorilor aferente regasite in bilantul tau contabil. ',
            adaugaBilant: 'Adauga Bilant',
            valoareInceput: 'Valoare Inceput',
            valoareSfarsit: 'Valoare Sfarsit',
            maiDeparte: 'Pasul Urmator',
            aiTerminat: 'Ai Terminat !',
            felicitariBilant: 'Felicitari ! Ai incheiat cu succes procesul de introducere a bilantului tau contabil anual',
            apasaFinalizeaza: 'Apasa finalizeaza pentru a fi condus la tabloul de comanda al sectiunii Diagnostic Financiar, sau apasa Vezi Raportul pentru a accesa un raport detaliat printabil. ',
            finalizeaza: 'Finalizeaza',
            adaugaClienti: 'Adauga Clienti',
            diagnosticFinanciar: 'Diagnostic Financiar',
            bilantAnual: 'Bilant Anual',
            informatiiDespreBilant: 'Informatii despre Bilant',
            clienti: 'Clienti',
            exercitiuFinanciar: 'Exercitiu Financiar',
            numarClienti: 'Numar Clienti',
            nrFacturiSold: 'Nr. Facturi Sold',
            totalSoldClienti: 'Total Sold Clienti',
            editeazaClienti: 'Editeaza Clienti',
            editeazaBilant: 'Editeaza Bilant',
            nuAvemClienti: 'Nu ai niciun client introdus in sistem pentru anul  ',
            adaugaClientNou: 'Adauga Client Nou',
            numeClient: 'Nume Client',
            facturi: 'Facturi',
            sold: 'Sold',
            salveaza: 'Salveaza',
            soldTotal: 'Sold Total',
            nuAvemFacturi: 'Nu avem nici o factura in sistem pentru acest client',
            adaugaFacturaNoua: 'Adauga Factura Noua',
            nrFactura: 'Nr Factura',
            dataEmitere: 'Data Emiterii',
            dataIncasarii: 'Data Incasarii',
            depasire: 'Depasire',
            valoareFactura: 'Valoare Factura',
            factura: 'Factura',
            serieFactura: 'Serie/Nr. Factura',
            valoareLei: 'Valoare Lei',
            introduClienti: 'Introdu Clienti sau Modifica datele despre un client pentru a beneficia de Analiza de Clienti',
            adaugareClientMesaj: '',
            dateDespreClientMesaj: 'Adauga toate facturile emise acestui client in anul ',
            dateDespreClientMesaj2: 'pentru a beneficia de Analiza de Clienti. Calculul pentru facturile intarziate se face cu o perioada de 30 de zile lucratoare.',
            dataScadenta: 'Data Scadenta',
            situatieGenerala: 'Situatie Generala',
            totalVenituri: 'Total Venituri',
            totalCheltuieli: 'Total Cheltuieli',
            totalProfit: 'Total Profit',
            situatie: 'Situatie',
            solduriClienti: 'Solduri Clienti',
            solduriClientiMesaj: 'Creante comerciale, avansuri pentru cumparari de bunuri de natura stocurilor si pentru prestari de servicii acordate furnizorilor si alte conturi asimilate, in sume brute. ',
            solduriFurnizori: 'Solduri Furnizori',
            solduriFurnizoriMesaj: 'Datorii comerciale, avansuri primite de la clienti si alte conturi asimilate, in sume brute.',
            analizaCashFlow: 'Analiza Cashflow',
            cheltuieliSiCosturi: 'Cheltuieli si Costuri',
            mesajAnalizaCashFlow: 'Aceasta zona de analiza se concentreaza asupra costurilor si cheltuielilor care sunt o parte din declaratia de profit si pierdere.',
            costuri: 'Costuri',
            cheltuieli: 'Cheltuieli',
            venituri: 'Venituri',
            fluxulDeNumerar: 'Fluxul de Numerar',
            planificareSiPrognoza: 'Planificare si Prognoza',
            mesajPrognoza: "Aceasta zona de analiza identifica valorile planificate si variatii de la acestea, precum si performanta planificata pe unitate. Indicatorii de performanta cheie analizati sunt 'Sume Prognozate' si 'Sume Planificate' ",
            planificare: 'Planificare',
            previzionat: 'Previzionat',
            analizaProfitPierdere: 'Analiza Profit / Pierdere',
            marjaComerciala: 'Marja Comerciala',
            marja: 'Marja',
            calificativ: 'Calificativ',
            trend: 'Trend',
            crestere: 'Crestere',
            scadere: 'Scadere',
            productiaExercitiului: 'Productia Exercitiului',
            valoare: 'Valoare',
            valoareAdaugata: 'Valoare Adaugata',
            excedentBrutDinExploatare: 'Excedent Brut din Exploatare',
            rezultatDinExploatare: 'Rezultat din Exploatare',
            rezultatulBrutAlExercitiului: 'Rezultatul Brut al Exercitiului',
            rezultatulNetAlExercitiului: 'Rezultatul Net al Exercitiului',
            rataRentabilitatiiEconomice: 'Rata Rentabilitatii Economice',
            tendintaRentabilitatiiEconomice: 'Tendinta Rentabilitatii Economice',
            rataRentabilitatiiFinanciare: 'Rata Rentabilitatii Financiare',
            tendintaRentabilitatiiFinanciare: 'Tendinta Rentabilitatii Financiare',
            analizaVanzariSiClienti: 'Analiza Vanzari si Clienti',
            top5Clienti: 'Sunt Afisati Top 5 Clienti',
            afisazaTotiClientii: 'Afiseaza Toti Clientii',
            numeClienti: 'Nume Clienti',
            analiza: 'Analiza',
            segmentare: 'Segmentare',
            analizaVanzarilorAditionale: 'Analiza Vanzarilor Aditionale si a Profitabilitatii',
            rataProfituluiBrut: 'Rata Profitului Brut',
            marjaNetaAProfitului: 'Marja Neta a Profitului',
            analizaSiRaportareProiecte: 'Analiza si Raportare Proiecte',
            top3Proiecte: 'Sunt Afisate Top 3 Proiecte',
            afisazaToateProiectele: 'Afiseaza Toate Proiectele',
            numeProiect: 'Nume Proiect',
            profitabilitate: 'Profitabilitate',
            totalOre: 'Total Ore',
            numeSarcina: 'Nume Sarcina',
            cheltuieli: 'Cheltuieli',
            buget: 'Buget',
            profit: 'Profit',
            analizaAngajatilor: 'Analiza Lucratorilor',
            top3Angajati: 'Sunt Afisati Top 3 Angajati',
            afisazaTotiAngajatii: 'Afiseaza Toti Angajatii',
            proiecte: 'Proiecte',
            rezolvat: 'Rezolvat',
            pretOra: 'Pret/Ora',
            pretTotal: 'Pret Total',
            proiect: 'Proiect',
            editeazaPlanificarea: 'Editeaza Planificarea',
            planificareVenituri: 'Planificare Venituri',
            lei: 'lei',
            analizaSiRaportareStocuri: 'Analiza si Raportare Stocuri',
            analizaStocurilor: 'Analiza Stocurilor',
            vitezaDeRotatieAStocurilor: 'Viteza de Rotatie a Stocurilor',
            diagnostic: 'Diagnostic',
            analizaCashFlowText: `Fluxul de numerar pozitiv (≥0 ) indică faptul că activele lichide ale unei companii
            sunt în creștere, permițându-i să își platească datoriile, să investeasca în continuare
            in afacere, să restituie banii acționarilor, etc, adica firma este profitabila (solvabila).
            Fluxul de numerar negativ (≤0) indică faptul că activele lichide ale unei companii
            sunt in scadere si inseamna ca firma nu este profitabila.
            Fluxul de numerar este folosit pentru a evalua calitatea veniturilor unei companii,
            ceea ce poate indica dacă societatea este solvabilă sau nu.`,
            prongozaText: `Planificarea se introduce manual si reprezinta ce isi propune societatea sa realizeze
            Prognoza (previzionat ) se bazează pe performanța trecută a companiei.`,
            rataRentabilitatiiEconomiceText: `O valoare sub 5% exprima faptul ca firma nu este rentabila din punct de vedere
            economic
            O valoare peste 7% exprima faptul ca firma este rentabila din punct de vedere
            economic`,
            tendintaRentabilitatiiEconomiceText: '',
            rataRentabilitatiiFinanciareText: `O valoare sub 25% exprima faptul ca firma nu este rentabila din punct de vedere
            financiar
            O valoare peste 25% exprima faptul ca firma este rentabila din punct de vedere
            financiar`,
            tendintaRentabilitatiiFinanciareText: '',
            analizaClientilorText: `Ajută​ ​organizaţia​ ​să​ ​înteleagă​ ​de​ ​ce​ ​clienţii​ ​sunt​ ​absorbiţi,​ ​migrează​ ​sau​ ​decid​ ​să​
            ​rămână.​ ​Prin​ ​această analiză​ ​puteţi​ ​identifica​ ​tendinţele​ ​cheie​ ​în​ ​ceea​ ​ce​ ​priveşte​
            ​uzura​ ​clienţilor​ ​ce​ ​pot​ ​ajuta​ ​la​ ​dezvoltarea​ ​unor programe​ ​eficiente​ ​de​ ​retenţie.​`,
            rataProfituluiBrutText: `Rata profitului brut, calculată ca un raport procentual între masa profitului brut şi
            costurile investite pentru obţinerea acestuia sau volumul capitalului folosit.
            Prin calcularea acestui raport se obţine gradul de rentabilitate pe produs, unitate
            economică, ramură industrială sau economie naţională.
            Rata profitului brut sub 1% indica o situatie instabila.
                Rata profitului brut cuprinsa intre 1% si 15% indica o situatie stabila.
                Rata profitului brut peste 15% poate indica o situatie volatila.`,
            marjaProfituluiBrutText: `Marja neta a profitului este un indicator financiar de profitabilitate, care ne arata in
            procente cat de profitabila este activitatea totala a unei companii.  
            Este o comparatie intre profitul ramas dupa impozit si vanzarile nete si arata profitul
            ramas dupa ce toate costurile de productie si de administratie au fost deduse din vanzari
            si impozitul pe profit recunoscut. Este una dintre cele mai bune masuri ale rezultatelor
            firmei in mod special daca este combinat cu o evaluare a modului in care este utilizat
            capitalul circulant.
            
            De regula, indicatorul se analizeaza in tendinta, de la o perioada la alta, insa se poate
            compara si cu rezultatele obtinute de competitori.`,
            solduriClientiText:`Crestere de peste 20% - nu isi incaseaza creantele SLAB, 
            Crestere de 19% - mediu, 
            Scadere de peste 20% - isi incaseaza creantele – FOARTE BINE`,
            solduriFurnizoriText:`Crestere de peste 20% - nu isi achita datoriile - SLAB,
            Crestere de 19% - MEDIU,
            Scadere de peste 20% - isi achita datoriile – FOARTE BINE`,
            analizaStocurilorText:`O analiza de stoc ar trebui sa poata sa scoata in evidenta problemele pe care le aveti
            cu stocurile si sa va dea solutii de remediere a acelor probleme.
            Reducerea valorii stocurilor, la fel ca optimizarea proceselor, este o activitate
            continua in companie, o activitate care trebuie facuta periodic cu scopul final de a
            reduce stocurile. Reducerea valorii stocurilor are efecte directe si rapide in cash flow-
            ul companiei.`,
            vitezaDeRotatieAStocurilorText:`Este un indicator care iti spune de cate ori se vinde stocul pe care il ai intr-o perioada de
            timp.
            Produsul BBB are o viteza de rotatie egala cu 1 inseamna ca, in aceasta luna, ai
            vandut o cantitate egala cu media stocului din aceasta luna (viteza medie).
            O viteza de 2 sau 3 arata ca ai vandut o cantitate de doua, respectiv trei ori mai
            mare decat stocul mediu (viteza buna)
            Viteza subunitara (de exemplu 0,3) indica faptul ca doar o fractiune din stocul tau a
            fost vandut: CCC ai vandut doar o treime din ceea ce ai avut (viteza slaba)`,
            raportGeneral:'Raport General',
            nuExistaSuficienteBilanturi:' Nu exista suficiente date in sistem, va rugam adaugati bilanturi pe minim 2 ani.',
            fataDeAnulTrecut:'Fata de anul trecut',
            slab:'Slab',
            mediu:'Mediu',
            foarteBine:'Foarte Bine',
            diagnostic:'Diagnostic',
            negativ:'Negativ',
            pozitiv:'Pozitiv',
            situatie:'Situatie',
            fluxPozitiv:'Flux de numerar pozitiv',
            fluxNegativ:'Flux de numerar negativ',
            buna:'Buna',
            inSistem:'in Sistem',
            companiaEInPierdere:'Compania este in pierdere',
            companiaEInProfitMediu:'Compania are o crestere medie a profitului',
            companiaEInProfit:'Compania e profitabila. Directia pe care te aflii este buna',
            rea:'Rea',
            viteza:'Viteza',
            loial:'Loial',
            nou:'Nou',
            pierdut:'Pierdut',
            bunPlatnic:'Bun Platnic',
            rauPlatnic:'Rau Platnic',
            importaBilant:'Importa Bilant',
            downloadTemplateBilant:'Download Template Bilant',
            download:'Download',
            venituriSiPreviziuni:'Venituri si Previziuni',
            cheltuieliSiPreviziuni:'Cheltuieli si Previziuni',
            nuExistSuficienteBilanturi:'Nu exista suficiente bilanturi in sistem, va rugam adaugati minim 2 bilanturi .',
            downloadTemplateClienti:'Download Template Clienti',
            importaClienti:'Importa Clienti'

        },


        economic:{
            economic:'Economic',
            selecteazaProiect:'Selecteaza un proiect de mai jos pentru a accesa zona de cheltuieli',
            buget:'Buget',
            cheltuieli:'Cheltuieli',
            bugetTotal:'Buget Total',
            cheltuieliTotal:'Cheltuieli Total',
            profit:'Profit',
            sarciniCuCheltuieli:'Sarcini cu Cheltuieli',
            utlilizatoriCuCheltuieli:'Utilizatori cu Cheltuieli',
            afisazaDupa:'Afiseaza Dupa',
            sumaCheltuieli:'Suma Cheltuieli',
            perioada:'Perioada',
            liniiBuget:'Linii Buget',
            liniiCheltuieli:'Linii Cheltuieli',
            alerte:'Alerte',
            operatiuni:'Operatiuni',
            denumireBuget:'Denumire Buget',
            valoareBuget:'Valoare Buget',
            modificat:'Modificat',
            denumireProdusServiciu:'Denumire Produs/Serviciu',
            cantitate:'Cantitate',
            pret:'Pret',
            tva:'TVA',
            totalPlusTva:'Total + TVA',
            denumireCheltuiala:'Denumire Cheltuiala',
            valoareCheltuiala:'Valoare Cheltuiala',
            alocatLaBuget:'Alocat La Buget',
            acestUtilizatorNuAreCheltuieli:'Acest utilizator nu are cheltuieli pentru acest proiect',
            etapa:'Etapa',
            perioada:'Perioada',
            atasamente:'Atasamente',
            direct:'Direct',
            bugetCuPersonal:'Buget cu Personal',
            cheltuialaCuPersonal:'Cheltuiala cu Personal',
            bugetTask:'Buget Task',
            bugetAlocatCheltuielii:'Buget Alocat Cheltuielii',
            downloadTemplateBilant:'Download Template Bilant',
            liniiChletuieli:'Linii Cheltuieli',
            valoare:'Valoare'

        },


        documenteProiecte:{
            managementDocumente:'Management Documente',
            proiecte:'Proiecte',
            documente:'Documente',
            veziToateDocumentele:'Vezi Toate Documentele',
            veziMaiPutin:'Vezi Mai Putin'

        },

        managementUtilizatori:{
            dateSalvate:'Datele au fost salvate',
            managementUtilizatori:'Management Utilizatori',
            lucratoriInterni:'Lucratori Interni',
            oras:'Oras',
            salariuBrut:'Salariu Brut',
            utilizatorNou:'Utilizator Nou',
            lucratoriExterni:'Lucratori Externi',
            companie:'Companie',
            salariuBrut:'Salariu Brut',
            costPeOra:'Cost / Ora',
            contulMeu:'Contul Meu',
            datePersonale:'Date Personale',
            nume:'Nume',
            numeIntreg:'Nume Intreg',
            cnp:'CNP',
            adresa:'Adresa',
            oras:'Oras',
            telefon:'Telefon',
            email:'E-Mail',
            adresaEmail:'Adresa E-Mail',
            dateProfesionale:'Date Profesionale',
            departament:'Departament',
            firma:'Firma',
            functie:'Functie',
            manager:'Manager',
            da:'Da',
            nu:'Nu',
            salariu:'Salariu',
            program:'Program',
            salveaza:'Salveaza',
            info:'Info',
            oParolaMaiPuternica:'O parola puternica are mai mult de 6 caractere contine litere mici,litere mari, cifre si un semn (@#$%&)',

            stergeUtilizator:'Doresti sa stergi definitiv utilizatorul ?',
            utilizatoriiNuPotFiRecuperati:'Utilizatorii odata stersi nu mai pot fi recuperati ',
            stergeDepartament:'Sunteti sigur ca vreti sa stergeti departamentul selectat ?',
            adaugaDepartament:'Adauga Departament',
            membruNou:'Membru Nou',
            managementDepartamente:'Management Departamente',
            detaliiProgram:'Detalii Program',
            creeazaProgramNou:'Creeaza Program Nou',
            denumireProgram:'Nume Program',
            nuExistaProgram:'Button Nu exista nici un program creat. Pentru a crea un nou program va rugam apasati pe butonul "Creeaza Program Nou"',
            pauza:'Pauza',
            oraIncepere:'Ora Incepere',
            oraFinalizare:'Ora Finalizare',
            luni:'Luni',
            marti:'Marti',
            miercuri:'Miercuri',
            joi:'Joi',
            vineri:'Vineri',
            sambata:'Sambata',
            duminica:'Duminica',
            selecteazaProgram:'Selecteaza Program',
            verifyCnp:'Cnp-ul nu este corect.',
            verifyTel:'Numarul de telefon nu este corect.',
            verifySerie:'Seria si numarul nu sunt corecte.'
            
        },



        proiecte: {
            permisConducere:'Permis Conducere',
            proiectNou:'Proiect Nou',
            dezArhiveazaProiect:'Dezarhivezi proiectul ?',
            proiectulDezarhivat:'Proiectul dezarhivat il vei gasi din nou in sectiunea proiecte.',
            arhivaProiecte:'Proiecte Arhivate',
            nrZileConcediu:'Nr. Zile Concediu',
            accessFinanciar:'Acces Financiar',
            alertView:'Nu aveti acces !',
            alertViewMessage:'Nu aveti acces la aceasta pagina, apasati ok pentru a reveni la ecranul principal ! ',
            tipIntroducere:'Tip Introducere',
            cheltuialaIndividuala:'Cheltuiala Individuala',
            bugetIndividual:'Buget Individual',
            bugetDefalcat:'Buget Defalcat',
            cheltuialaDefalcata:'Cheltuiala Defalcata',
            valoare:'Valoare',
            denumireCheltuiala:'Denumire Cheltuiala',
            etapaProiectului:'Etapa Proiectului',
            definesteCheltuielile:'Defineste cheltuielile pentru bugetul proiectului ',
            creeazaProiectNou:'Creeaza Un Proiect Nou',
            archiveProject: 'Arhivezi proiectul ?',
            archiveProjectMessage: 'Proiectele arhivate pot fi accesate in orice moment din zona Arhive regasita in meniu. ',
            deleteProject: 'Doresti sa stergi definitiv proiectul ?',
            deleteProjectMessage: 'Proiectele sterse nu mai pot fi accesate. Ia in considerare functia Arhivare',
            yes: 'Da',
            no: 'Nu',
            ok: 'Ok',
            dateStart: 'Data Inceput',
            dateFinish: 'Data Sfarsit',
            projectManagement: 'Management de Proiecte',
            viewDetails: 'Vezi detalii',
            complete: 'Complet',
            department: 'Departament',
            taskDelay: 'Motiv intarziere task',
            taskDelay: 'Motiv intarziere task aici',
            finalize: 'Finalizeaza',
            taskDelete: 'Doresti sa stergi taskul selectat?',
            deleteTaskMessage: 'Aceasta functie este ireversibila iar taskul nu mai poate fi recuperat ! ',
            dateMsgAlert: 'Data de inceput nu poate fi mai mare decat data de sfarsit !',

            informatiiProiect: {
                titlu: 'Titlu',
                deLa: 'De la',
                panaLa: 'Pana la',
                descriere: 'Descriere',
                upload: 'Upload Document',
                dataDoc: 'Data Upload',
                stergeDoc: 'Sterge Document'
            },

            etapeProiect: {
                titluInsertDialog: 'Adauga Etapa',
                denumire: 'Nume Etapa',
                dela: 'De la',
                panala: 'Pana la',
                responsabil: 'Aici selecteaza responsabilul etapei',
                addEtapa: 'Adauga o etapa',
                addTask: 'Adauga task',
                markComplete: 'Marcheaza Finalizat',
                completat: 'Finalizat',
                selectDate: 'Selecteaza Data',
                numeTask: 'Task Nou',
                atribuitLui: 'Atribuit lui',
                deLaOra: 'De la ora',
                panaLaOra: 'Pana la ora',
                descriereTask: 'Descriere',
                editeazaNumeSiDescriere: 'Editeaza numele & descrierea',
                numeEtapa: 'Nume',
                deleteEtapa: 'Sunteti siguri ca vreti sa stergeti etapa',
                subTask: 'Adauga un nou subtask',
                timpEstimat: 'Timp estimat de lucru',
                data: 'Data',
                ore: 'Ore',
                minute: 'Minute',
                zileCumulate: 'Zile Cumulate',
                selecteazaUser: 'Selecteaza User',
                documenteTask: 'Documente Task',
                documenteEtape: 'Documente Etape',

            },
            nameTask: 'Click aici si numeste aceasta sarcina ',
            name: 'Nume',
            responsable: 'Responsabil',
            selectUser: 'Selecteaza User',
            date: 'Data',
            budget: 'Buget',
            budgetName: 'Denumire Buget',
            budgetValue: 'Valoare Buget',
            operations: 'Operatiuni',
            total: 'Total',
            spendings: 'Cheltuieli',
            spendingName: 'Denumire cheltuiala',
            spendingValue: 'Valoare cheltuiala',
            description: 'Descriere',
            taskDetali: 'Mai multe detalii despre sarcina',
            addDescription: 'Adauga o descriere',
            delays: 'Intarzieri',
            whyDelayedTask: 'De ce este taskul intarziat ?',
            addAttachment: 'Adauga atasament',
            save: 'Salveaza',
            delete: 'Sterge',
            spendingManagement: 'Administrare cheltuiala',
            typeSelect: 'Selecteaza Tipul',
            spendingType: 'Tip cost',
            addType: 'Tip introducere',
            denumire: 'Denumire',
            quantity: 'Cantitate',
            price: 'Pret',
            tvaIncl: 'Tva Incl.',
            tva: 'TVA',
            valTva: 'Val. TVA',
            denumireProdus: 'Denumire Produs',
            value: 'Valoare',
            sum: 'Suma',
            alocaBuget: 'Aloca buget',
            bugetAlocat: 'Buget Alocat',
            addNewProduct: 'Adauga produs nou',
            worker: 'Lucrator',
            hours: 'Ore',
            hour: 'Ora',
            addNewWorker: 'Adauga lucrator nou',
            selectUser: 'Selecteaza Utilizator',
            budgetManagement: 'Administreaza Buget',
            budgetType: 'Tip Buget',
            viewMode: 'Mod vizionare',
            denumireTask: 'Denumire task',
            select: 'Selecteaza',
            clickNewTask: 'Click aici pentru a crea o sarcina noua',
            welcomeToIdeaView: 'Bine ai venit in modul de vizionare',
            idea: 'idee',
            ideaViewMessage: `a proiectului tau. Acest mod este gandit pentru a te ajuta sa construiesti repede, intr-un mod vizual ideea proiectului tau.
            Mai jos regasesti stadiile proiectului tau create in pasii anteriori. Tine mouse-ul deasupra unui stadiu de proiect pentru a adauga taskuri`,
            stage: 'Stadiul',
            duration: 'Durata',
            gradDeCompletare: 'Grad de completare',
            taskNumber: 'Numar de taskuri',
            selectTaskToExpand: 'Selecteaza unul din stadiile proiectului de mai sus pentru a accesa taskurile si subtaskurile sale',
            noTaskAdded: 'Nu ai adaugat nici o sarcina in proiectul tau. Pentru a continua planificarea proiectului tau, selecteaza etapa cu care doresti sa incepi si adauga sarcini.',
            completedAt: 'Completat la',
            subtasksNumber: 'Numar de subtaskuri',
            subtasksTermenDepasit: 'Subtaskuri cu termen depasit',
            subtaskTermenDepasit: 'Subtask cu termen depasit',
            manageTask: 'Administreaza sarcina',
            modifyInteractiveData: 'Modifica Interactiv Datele',
            newTask: 'Sarcina noua',
            noTaskInEtapa: ' Nu ai nici o sarcina in aceasta etapa. Adauga o sarcina de la butonul de mai jos.',
            dateDespreNoulProiect: 'Cateva date despre noul tau proiect',
            denumireProiect: 'Denumire Proiect',
            exPoianaMarului: 'Ex:Pensiune Poiana Marului',
            projectDescription: 'Descriere Proiect',
            projectDescriptionPlaceHolder: 'O scurta descriere a proiectului',
            beneficiarProiect: 'Beneficiar Proiect',
            beneficiarProiectPlaceHolder: 'Ex: SC. NUMECOMPANIE S.R.L',
            cui: 'CUI',
            dataInceputProiect: 'Data Inceput Proiect',
            dataSfarsitProiect: 'Data Sfarsit Proiect',
            step2Project: 'Pasul 2: Defineste Utilizatori',
            utilizatoriProiecte: 'Defineste utilizatorii care lucreaza pe acest proiect',
            selectUsers: 'Selecteaza Utilizatori',
            newUser: 'Utilizator nou',
            step3Project: 'Pasul 3: Defineste Etapele Proiectului',
            stepBack: 'Pasul anterior',
            userName: 'Nume Utilizator',
            departamentIntern: 'Departament Intern ',
            companieExterna: 'Companie Externa',
            datePersonale: 'Date Personale',
            cnp: 'CNP',
            adresa: 'Adresa',
            oras: 'Oras',
            telefon: 'Telefon',
            email: 'E-mail',
            adresaEmail: 'Adresa de E-mail',
            password: 'Parola',
            reapeatPassword: 'Repeta Parola',
            dateServiciu: 'Date Serviciu',
            esteManager: 'Este Manager',
            selectDepartment: 'Selecteaza Departament',
            firma: 'Firma',
            functie: 'Functie',
            salariu: 'Salariu',
            salariuBrut: 'Salariu Brut',
            costOra: 'Cost / Ora',
            accesDepartamente: 'Acces Departamente',
            cV: 'Curriculum Vitae',
            fisaPostului: 'Fisa Postului',
            program: 'Program',
            alertDataEtapa: 'Data de inceput a etapei nu poate fi mai mare decat data de sfarsit !',
            alertDataEtapaSfarsit: 'Data de sfarsit a etapei nu poate fi mai mica decat data de inceput !',
            creeazaEtape: 'Creeaza etapele proiectului',
            taskuriDepasite: 'Taskuri cu termen depasit',
            taskDepasit: 'Task cu termen depasit',
            perioadaProiectului: 'Perioada proiectului',
            denumireEtapa: 'Denumire etapa',
            denumireEtapaPlaceholder: 'Denumirea primei etape',
            selecteazaResponsabilEtapa: 'Selecteaza utilizator responsabil',
            descriereEtapa: 'Descriere etapa',
            dateEtapa: 'Date etapa',
            salveazaEtapa: 'Salveaza etapa',
            creeazaEtape: 'Creeaza etapele proiectului',
            etapa: 'Etapa',
            addEtapa: 'Adauga etapa',
            step4Projects: 'Pasul 4: Defineste Buget',
            selectEtapaProiect: 'Selecteaza etapa proiectului',
            spreTaskuri: 'Spre introducere taskuri',


            numeProiect: 'Nume Proiect',
            numeUser: 'Nume Utilizator',
            legenda: 'Legenda',
            detaliiProiect: 'Detalii Proiect',
            segmentButtons: {
                informatii: 'Informatii',
                etape: 'Etape',
                taskuri: 'Taskuri',
                drepturi: 'Management Utilizatori',
                costuri: 'Bugetul Proiectului',
                documente: 'Documente Proiect',
                rapoarte: 'Rapoarte'
            },
            status: {
                finalizata: 'Finalizat',
                blocat: 'Intarziat',
                inlucru: 'In lucru',
                inviitor: 'In viitor'
            },





            rapoarteProiect: {
                situatiiGenerale: 'Situatii Generale',
                situatiiEtape: 'Situatii Etape',
                nrTaskuriCompletateDepasite: 'Nr. taskuri completate depasite',
                nrTaskuriCompletateInTermen: 'Nr. taskuri completate in termen',
                nrTaskuriDeschise: 'Nr. taskuri deschise',
                nrTaskuriDeschiseDepasite: 'Nr. taskuri deschise depasite',
                nrTaskuriFinalizate: 'Nr. taskuri finalizate',
                nrTotalTaskuri: 'Nr. total taskuri',
                nrUtilizatori: 'Nr. utilizatori',
                ordoneazaDupa: 'Ordoneaza dupa',

                calificativMedie: 'Calificativ medie',
                medieAvansPerTask: 'Medie avans / task',
                medieDepasirePerTask: 'Medie depasire / task',
                medieGenerala: 'Medie generala',
                nrTaskuriAvans: 'Nr. taskuri avans',
                nrTaskuriDepasite: 'Nr. taskuri depasite',
                nrTaskuriTermen: 'Nr. taskuri termen',
                nrTotalTaskuri: 'Nr. total taskuri',
                totalOreAvans: 'Total ore avans',
                totalOreDepasire: 'Total ore depasire',
                totalOreCumulateTaskuri: 'Total ore cumulate taskuri',
                totalOreDiferentaCompletare: 'Total ore depasire completare',
                totalOreAvansCompletare: 'Total ore avans completare',
                pctDepasire: 'Procentaj depasire taskuri ',
                pctAvans: 'Procentaj avans taskuri',


                numeUser: 'Nume utilizator',
                numeProiect: 'Nume proiect',
                deLa: 'De la data',
                panaLa: 'Pana la data',
                numeTask: 'Nume task',
                durataOre: 'Durata ore'

            }


            
        },


        alertDate: {
            subTask: 'Data selectata nu se incadreaza in perioada taskului de care apartine !',
            etapa: 'Data selectata nu se incadreaza in perioada proiectului de care apartine sau data de inceput este mai mica decat etapa precedenta!',
            task: 'Data selectata nu se incadreaza in perioada etapei de care apartine !',
            document: 'Sunteti sigur ca vreti sa stergeti documentul ?'
        },
        clienti: {
            nume: 'Nume',
            adresa: 'Adresa',
            oras: 'Oras',
            nationalitate: 'Nationalitate',
            limba: 'Limba',
            educatie: 'Educatie',
            clasaSociala: 'Clasa Sociala',
            sex: 'Sex',
            religie: 'Religie',
            rasa: 'Rasa',
            nrMembriiFamilie: 'Numar Membrii Familie',
            ocupatie: 'Ocupatie',
            stilViata: 'Stil de viata',
            venit: 'Venit',
            note: 'Note',
        },




        administrare: {
            mesagerie: 'Mesagerie',

        },
        mesagerie: {
            trimiteUtilizatori: 'Trimite emailuri catre utilizatori',
            trimiteSumar: 'Trimite sumarul zilei'
        },
        chestionareCategorii: {
            descriere: 'Descriere chestionar',
            cumArataRezultatele: 'Cum arata rezultatele',
            numarulDeIntrebari: 'Numarul de intrebari',
            timpCompletare: 'Timp estimat',
            templateChestionare: 'Categorii Template',
            chestionareleMele: 'Evaluarile Mele',
            adaugaEval: 'Creeaza Evaluare',
            anuleazaEval: 'Anuleaza Evaluare',
            addEval: 'Adauga Evaluare',
            chestionareRealizate: 'Evaluari Realizate',
            evalNoua: 'Evaluare noua',
            evalInCurs: 'Evaluari in curs',
            evalCompletate: 'Evaluari Completate',
            adaugaCompletatori: 'Adauga Evaluator',
            adaugaIntrebare: 'Pentru a adauga o intrebare trageti-o cu mouse-ul deasupra acestui dreptunghi',
            intrebari: 'Intrebari',
            intrebare: 'Intrebare',
            categoriileMele: 'Evaluarile Mele',
            raspunsuriPredefinite: 'Raspunsuri Predefinite'

        },

        financiarContabil: {
            selecteazaAnul: 'Selecteaza anul',
            selecteazaLuna: 'Selecteaza luna',
            selecteazaZi: 'Selecteaza Zi',
            luna: 'Luna',
            nume: 'Nume',
            anul: 'Anul',
            rau: 'Rau',
            slab: 'Slab',
            bun: 'Bun',
            foarteBun: 'Foarte Bun',
            prognoza: 'Venituri si previziuni',
            analizaUtilizatori: 'Analiza utilizatori',
            analizaFinanciara: 'Analiza si raportare financiara',
            analizaCashFlow: 'Analiza cash flow',
            analizaProiecte: 'Analiza Proiecte',
            selecteazaIndicator: 'Selecteaza Indicator',
            valoare: 'Valoare',
            balante: 'Balante',
            bilanturi: 'Bilanturi',
            cont: 'Cont',
            tip: 'Tip',
            client: 'Client',
            variatie: 'Variatie',
            evolutie: 'Evolutie',
            analizaDeVanzariSiClienti: 'ANALIZA DE VANZARI SI CLIENTI',
            evolutiaSolduluiPeClient: 'EVOLUTIA SOLDULUI PE CLIENT',
            clientiCastigatiLunar: 'CLIENTI NOI CASTIGATI LUNAR',
            lunaCurenta: 'LUNA CURENTA',
            lunaAnterioara: 'LUNA ANTERIOARA',
            acum2Luni: 'ACUM 2 LUNI',
            clientiPierduti: 'CLIENTI PIERDUTI',
            nuExista: 'NU EXISTA DATE',
            clientiCastigati: 'CLIENTI CASTIGATI',
            clientiLoiali: 'CLIENTI LOIALI',
            clientiActivi: 'CLIENTI ACTIVI',
            comparatieRealizatPlanificat: 'COMPARATIE REALIZAT - PLANIFICAT',
            venituri: 'Venituri',
            cheltuieli: 'Cheltuieli',
            venituriPlanificate: 'Venituri Planificate',
            cheltuieliPlanificate: 'Cheltuieli Planificate',
            facturi: 'FACTURI',
            document: 'Document',
            termen: 'Termen',
            total: 'Total',
            facturiNeincasate: 'Facturi Neincasate',
            facturiInTermen: 'Facturi In Termen',
            valoareAnterioara: 'Valoare Anterioara',
            valoareCurenta: 'Valoare Curenta',
            initiala: 'Initiala',
            finala: 'Finala',
            anticipata: 'Anticipata',
            totalOreCumulateTaskuri: 'Total ore cumulate taskuri',
            totalOreDepasiteCompletare: 'Total ore depasite completare',
            totalOreAvansCompletare: 'Total ore avans completare',
            procentajDepasire: 'Procentaj depasire',
            procentajAvans: 'Procentaj Avans',
            durata: 'Durata',
            etape: 'Etape',
            taskuri: 'Taskuri',
            pozitiva: 'Pozitiva',
            negativa: 'Negativa',
            stationara: 'Stationara',
            alertExistaBilant: 'Exista deja bilant pentru anul selectat, daca vreti sa continuati fisierul se va suprascrie !',
            importaBilant: 'Importa Bilant',
            importaBalanta: 'Importa Balanta',
            importaClienti: 'Importa Clienti',
            istoricIndicatoriFinanciari: 'Istoric indicatori financiari',
            balanteSiBilanturi: 'Balante si bilanturi',
            planificare: 'Planificare',
            selecteazaFisier: 'Selecteaza Fisier',
            succesImportBilant: 'Succes import bilant',
            solduriClienti: 'Solduri clienti',
            debit: 'Debit',
            credit: 'Credit',
            solduriFurnizori: 'Solduri Furnizori',
            utilizatorulTerminaTaskurileInainteDeTermen: 'Utilizatorul termina majoritatea taskurilor inainte de termen cu aproximativ',
            utilizatorulDepasesteTaskurile: 'Utilizatorul de regula depaseste taskurile cu aproximativ',
            fisaClientului: 'Fisa Clientului',
            nrFacturi: 'Nr Facturi',
            totalDeIncasat: 'Total de incasat',
            nuSePoateCalcula: 'Nu se poate calcula',
            criteriul: 'Criteriul',
            clasificare: 'Clasificare',
            anulAnterior: 'Anul Anterior',
            segmentareClientiInFunctieDeCaracteristici: 'SEGMENTARE CLIENTI IN FUNCTIE DE CARACTERISTICI',
            educatie: 'EDUCATIE',
            ocupatia: 'Ocupatia',
            clasaSociala: 'Clasa Sociala',
            limba: 'LIMBA',
            nationalitate: 'NATIONALITATE',
            numarMembriiFamilie: 'NUMAR MEMBRII FAMILIE',
            ocupatie: 'OCUPATIE',
            rasa: 'RASA',
            religie: 'RELIGIE',
            sex: 'SEX',
            masculin: 'Masculin',
            feminin: 'Feminin',
            stilDeViata: 'STIL DE VIATA',
            venit: 'VENIT',
            trendPastrareClientiTrimestru: 'TREND PASTRARE CLIENTI TRIMESTRU',
            trimestrul: 'Trimestrul'


        },




        noData: 'Neplanificat',




        date: 'ro',







        organigrama: {
            nume: 'Nume',
            email: 'Email',
            telefon: 'Telefon',
            adresa: 'Adresa',
            sef: 'Sef',
            oras: 'Oras',
            fisa: 'Fisa Postului',
            veziFisa: 'Deschide Fisa',
            adaugaFisa: 'Adauga Fisa',
            cv: 'Curriculum Vitae',
            adaugaCv: 'Adauga CV',
            veziCv: 'Deschide CV',
            programLucru: 'Program Lucru',
            inceputProg: 'Inceputul Programului',
            sfarsitProg: 'Sfarsitul Programului',
            cost: 'Cost/min',
            dateleFirmei: 'Datele Firmei',
            cui: 'CUI',
            tip: 'Tip',
            nrInregistrare: 'Nr. registrul comertului',
            tva: 'TVA',
            tipMoneda: 'Tip Moneda'
        },

        zileleSapt: {
            luni: 'Luni',
            marti: 'Marti',
            miercuri: 'Miercuri',
            joi: 'Joi',
            vineri: 'Vineri',
            sambata: 'Sambata',
            duminica: 'Duminica'
        },
        luni: {
            ianuarie: 'Ianuarie',
            februarie: 'Februarie',
            martie: 'Martie',
            aprilie: 'Aprilie',
            mai: 'Mai',
            iunie: 'Iunie',
            iulie: 'Iulie',
            august: 'August',
            septembrie: 'Septembrie',
            octombrie: 'Octombrie',
            noiembrie: 'Noiembrie',
            decembrie: 'Decembrie'
        },
        pontaj: {
            oreLucrate: 'Ore Lucrate',
            concedii: 'Concedii',
            contractDeMunca: 'Contract de munca',
            protectiaMuncii: 'Protectia Muncii',
            dosareDeSanatate: 'Dosare de sanatate',
            studii: 'Studii',
            cv: 'CV',
            rude: 'Rude (Parinti, Copii)',
            pasiuni: 'Pasiuni',
            cursuri: 'Cursuri',
            evaluareProfesionala: 'Evaluare Profesionala',
            angajati: 'Angajati',
            saptamana: 'O Saptamana',
            luna: 'O Luna',
            ansamblu: 'Ansamblu',
            treiLuni: '3 Luni'
        },

        bugete: {
            nume: 'Nume',
            proiecte: 'Proiecte',
            contabilitate: 'Contabilitate',
            intern: 'Intern',
            addBudget: 'Adauga Buget',
            budgets: 'Bugete',
            costs: 'Costuri',
            addCost: 'Adauga Cost',
            adaugatEditat: 'Adaugat/Editat de',
            adaugatLa: 'Adaugat la data',
            angajatiAlocati: 'Angajati alocati proiectului',
            nrTaskuri: 'Taskuri alocate user / proiect',
            nrTaskuriT: 'Taskuri alocate user'
        },




    }














    ///DICT ENGLISH


    

    dictENG = {


        appBar: {
            drawer: {
                home: 'Home',
                projectsManagement: 'Project Management',
                projects: 'Projects',
                economic: 'Economic',
                documentsManagement: 'Document Management',
                monitorizareaAngajatilor: 'Employee Monitoring',
                financial: 'Financial Diagnosis',
                pontaj: 'Clocking',
                evaluations: 'Evaluations',
                colegueEvaluations: 'Evaluation by colleagues',
                questionariesEvaluations: 'Evaluations Questionnaires',
                managementEvaluations: 'Employee evaluation by bosses',
                generalEvaluation: 'General evaluation',
                clientsEvaluations: 'Employee evaluation by customers',
                administrare: 'Administration',
                userManagement: 'User Administration',
                departmentManagement: 'Department Administration',
                logout: 'Log Out',
                setari: 'Settings',
                resurseUmane: 'Human resources',
                rapoarte: 'Reports',
                ticheteDeMasa: 'Meal tickets',
                documenteHR: 'Documents',
                candidati: 'Candidates',
                operatiuni: 'Operations',
                raportareMonitorizare: 'Reports',
                managementBilanturi: 'Balance Sheet Management',
                timpLucru:'Working Time',
                monitorizare:'Monitoring',
                evaluareFinanciara:"Financial Evaluation",
                evaluareaActivitatiiAngajatilor:'Employee Activity Evaluation',
                selectiePersonal:'Employee Selection'

            },


            buttons: {
                inapoi: 'Back',
                insertUser: 'Add user',

            }
        },

        home: {
            controlPanel: 'Control Panel',
            mesajPanouControl:'For actions please click on the button on the top left.',
            limba:'Language',
            downloadApp:'Download App',
            downloadMonitorizare:'Download Monitoring App'

        },

        login: {
            user: 'Email',
            password: 'Password',
            or: 'Or',
            signUp: 'Sign Up',
            logIn: 'Log In',
            repeatPass: 'Repeat Password',
            passWarn: 'The passwords are not the same',
            userWarn: 'Email is incorrect',
            societyName: 'Company Name',
            cui: 'CUI',
            userName: 'User Name',
            repeatPassword: 'Repeat Password',
            wantToLogIn: 'Do you want to log in? ',
            clickHere: 'Click here',
            noAccount: "Don't have an account? ",
            parolaGresita:`You have tried to login 10 times without success, your access have been blocked for 15 minutes.`
        },

        comune: {
            add: 'Add',
            save: 'Save',
            detailsView: 'Details',
            search: 'Search',
            edit: 'Edit',
            theme: 'Theme',
            yes: 'Yes',
            no: 'No',
            ok: 'Ok',
            sterge: 'Delete',
            adaugaProgramCompanie:'Add Company Time Schedule'
        },

        settings: {
            title: "Settings",
            nume: 'Name',
            email: 'Email',
            telefon: 'Phone',
            accessProjects: 'Access Projects',
            createProjects: 'Create Projects',
            modifyEmployees: 'Edit Employees',
            deactivateAccount: 'Deactivate Account',
            alertDeactivate: 'Are you sure you want to deactivate the account?',
            isAdmin: 'Admin',
            doarCitire: 'Read Only',
            drepturiExtinse: 'Extended Rights',
            valoare: 'Value',
            dataCost: 'Data Cost',
            note: 'Notes',
            explicatii: 'Explanations',
            responsabil: 'Responsible level',
            veziProiecte: 'View Projects',
            tipDocument: 'Docs for'
        },
        evaluari: {
            denumireRaport:'Report Name',
            afisarePentru:'Show For',
            rezultatePentru:'Results For',
            alertStergeSesiune: 'Do you want to delete the selected session?',
            alertStergeSesiuneMessage: 'Attention! Once deleted, the session cannot be recovered. ',
            evaluareColegi: 'Evaluation by Colleagues ',
            creeazaDenumireEvaluare: 'Create a name for this evaluation session.',
            numeSesiune: 'Session Name',
            pasulUrmator: 'Next step',
            nuExistaSesiuneColegi: 'There is no active staff evaluation session by colleagues. Start a new evaluation by clicking the button below',
            sesiuneNoua: 'New Session',
            sesiuneEvaluare: 'Evaluation Session',
            completare: 'COMPLETION',
            finalizat: 'COMPLETED',
            nuAiChestionarSalvatSistem: 'Total Suite ratings are based on questionnaires. I noticed that you do not have any evaluation questionnaire saved in the system',
            clickAici: 'Click Here',
            pentruACreaUnChestionarAcum: 'to create a questionnaire now.',
            astazi: 'Today',
            evaluareClienti: 'Evaluation by Customers',
            nuExistaSesiuneClienti: 'There is no active staff evaluation session by clients. Start a new evaluation by clicking the button below',
            evaluareManager: 'Evaluation by the Manager',
            nuExistaSesiuneManageri: 'There is no active staff evaluation session by the manager. Start a new evaluation by clicking the button below',
            alertStergeEvaluare: 'Do you want to delete the selected evaluation?',
            alertStergeEvaluareMessage: 'Attention! The once deleted evaluation cannot be recovered. ',
            alertStergeRaport: 'Do you want to delete the selected report?',
            alertStergeRaportMessage: 'Attention! The report once deleted cannot be recovered. ',
            evaluareGenerala: 'General Evaluation',
            titluSesiuneGenerala: 'General Session Title',
            sesiuneGenerala: 'General Session',
            titluSesiuneColegi: 'Colleagues Session Title',
            sesiuneColegi: 'Colleagues Session',
            titluSesiuneManager: 'Manager Session Title',
            sesiuneManager: 'Manager Session',
            titluSesiuneClienti: 'Client Session Title',
            sesiuneClienti: 'Client Session',
            creeaza: 'Create',
            selecteazaSauCreeaza: 'Select one of the evaluation sessions below or create a new session',
            mesajCreeazaEvaluareGenerala: `You are about to initiate a general evaluation session. This evaluation contains all 3 types of evaluations possible in Total Suite, namely Evaluation by Colleagues, Evaluation by Manager
            and Customer Evaluation. These Evaluations will also be found in their individual sections but will be centralized here. We recommend that you create a special form for this type of evaluation. Learn more about the General Assessment Form`,
            aici: 'Here',
            alegeOptiune: 'Select an option',
            sesiuneGeneralaNoua: 'New general session',
            inapoi: 'Back',
            nuExistaSesiuneGenerala: 'There is no active general evaluation session. Start a new evaluation by clicking the button below',
            combinaEvaluariExistente: 'Combine Existing Evaluations',
            creeazaRaportGeneral: 'Create a General report',
            scorTotal: 'TOTAL SCORE ',
            veziRaport: 'View report',
            departament: 'Department',
            data: 'Date',
            evaluatori: 'Evaluators',
            completareNoCaps: 'Completion',
            puncte: 'Points',
            finalizeazaSesiunea: 'End the Session',
            sesiuneChestionareDiferite: 'The individual evaluation sessions in this general session are built on different questionnaires. For this reason, the general report is built only according to the scores of the respective sessions.',
            rapoarteSalvate: 'Saved Reports',
            evaluareNoua: 'New Evaluation',
            sesiunea: 'Session',
            finalizatNoCaps: 'Completed',
            persoaneRaport: 'Select the people or departments you want to be included in the report and click the Create Report button',
            creeazaRaport: 'Create Report',
            peCineEvaluezi: 'Who do you want to evaluate?',
            selecteaza: 'Select',
            alegeDepartament: 'Choose the department',
            formularEvaluare: 'Evaluation form',
            alegeFormular: 'Choose the form',
            administrareFormulare: 'for form administration',
            creeazaEvaluarea: 'Create the evaluation',
            selecteazaEvaluatori: 'Select Evaluators',
            evaluatoriAlgoritm: 'Evaluators for each person evaluated according to the following algorithm',
            persoaneAcelasiDepartament: 'people from the same department ',
            persoaneLaIntamplare: 'people chosen at random so as to cover as many departments as possible ',
            dateAngajat: 'Employee data',
            numeAngajat: 'Name',
            functieAngajat: 'Function',
            colegiInDept: 'Colleagues in dept',
            dateDepartament: 'Data about the department',
            angajati: 'Employees',
            utlimaEvaluare: 'Last Evaluation',
            dataUltimaEvaluare: 'Date of last evaluation',
            nrEvaluatori: 'Number of Evaluators',
            din: 'from',
            evaluatoriSelectati: 'selected evaluators',
            selecteazaSauAdaugaClienti: 'Select or add customers',
            selecteazaSauAdaugaClientiMessage: 'Select the Clients who will evaluate the employee from the list below or manually add the Name and E-mail Address. Make sure you select or add clients who have actually worked with this employee.',
            clientiSelectati: 'Selected customers',
            clientiEvaluatoriAdaugati: 'Evaluators Added',
            adaugaManualClienti: 'Manually add customers',
            numeSiPrenume: 'Name and Surname',
            adresaEmail: 'Email Address',
            selecteazaClientiExistenti: 'Select Existing Customers',
            adaugaClientiSelectati: 'Add selected customers',
            salveazaSiInchide: 'Save and close',
            mesajEvaluareClienti: ` You are about to initiate an evaluation session for more than one person. In the next steps you must declare a maximum number of 10 clients for each evaluated person.
            Add or select clients who have worked with those people. Click the green Create Evaluation button to start the process.`,
            urmatorulEvaluat: 'Next Rated',
            selecteazaClienti: 'Select Customers',
            tipEvaluareClientiMesaj: 'For this type of evaluation you must add or select a maximum of 10 Clients who have worked with this person. Click the button below to get started ',
            adaugaClienti: 'Add Customers',
            administrareClienti: 'Manage Customers',
            din10Evaluatori: 'from 10 Clients Evaluators Added',
            initiazaEvaluarea: 'Initiate the evaluation',
            selecteazaManageriEvaluatori: 'Select Evaluator Managers',
            selecteazaClientiEvaluatori: 'Select Evaluating Clients ',
            lucratoriDepartament: 'Department workers',
            lucratoriCompanie: 'Company workers',
            conditiiIndeplinite: 'All conditions are met! ',
            conditiiIndepliniteMesaj: 'Congratulations! All the conditions to start the General Evaluation Session are met. At this point you can change your choices for each employee by clicking on his name.',
            apasaButonulVerde: 'Press the green button',
            initiazaEvaluareaPentruADemara: 'Initiate the Evaluation to start this session',

        },


        pontaje: {

            evaluareColegi:'Evaluation by Colleagues', 
            evaluareManager:'Evaluation by Manager', 
            evaluareClienti:'Evaluation by Clients',
            evaluareGenerala:'General Evaluation',
            dataGenerarii:'Date Created',

            prezentProgramNormal:'Present - normal schedule',
            prezent:'Present',
            absentaNemotivata:'Unmotivated Absence',
            absentaInvoire:'Absent Invoice',
            invoireFaraAbsenta:'Invoice(Not Absent)',
            oreSuplimentare:'Overtime',
            cFaraPlata:'Unpaid Leave',
            cOdihna:'Holiday',
            cMedical:'Sick Leave',
            cMedicalAccident:'Sick Leave,  Accident,Ocupational Disease, Quarantine',
            cMaternitate:'Maternity Leave, Paternity, Child Raise, Child Care',
            cEvenimenteSpeciale:'Leave Special Events',
            cAcomodare:'Accommodation Leave,Notice Leave',


            operatiuniCandidati:'Candidates Operations',
            rapoarte:'Reports',
            nuExistaProgram:`The user doesn't have a schedule on this day.`,
            vaRugamAdaugatiProgram:'Please add a schedule for this user.',
            nrZileConcediu:'Nr. Vacation Days',
            resurseUmane: 'Human Resources',
            calendarPontaj: 'Timing Calendar',
            legenda: 'Legend',
            toate: 'All',
            departamentCautaLucrator: 'Department / Search Worker',
            functie: 'Function',
            departament: 'Departament',
            zileConcediuRamase: 'Holidays left',
            evenimenteAnulCurent: 'Events in the Current Year',
            adaugaEvenimentNou: 'Add a New Event',
            dataInceput: 'Star Date',
            dataSfarsit: 'Completion Date',
            tipEveniment: 'Event Type',
            adaugaEvenimentul: 'Add Event',
            dataEveniment: 'Event Date',
            oraIncepere: 'Start time',
            oraFinalizare: 'Completion time',
            operatiuniResurseUmane: 'Human Resources Operations',
            dataAngajarii: 'Date of Employment',
            incadrareSalariala: 'Salary classification',
            ticheteDeMasa: 'Meal tickets',
            operatiuni: 'Operations',
            candidati: 'Candidates',
            angajareNoua: 'New Employment',
            dataInterviu: 'Interview Date',
            specializari: 'Specializations',
            candidat: 'Candidate',
            candidatNou: 'New Candidate',
            status: 'Status',
            dateCompanie: 'Company Data',
            email: 'Email',
            nrTelefon: 'Phone',
            oras: 'City',
            adresa: 'Address',
            permis: 'Driving License',
            editeaza: 'Edit',
            demisieConcediere: 'Resignation/Dismissal',
            incadrare: 'Supervised',
            programLucru: 'Work program',
            balantaConcediu: 'Holiday Balance',
            concediu: 'Vacation',
            odihna: 'Rest',
            zile: 'Days',
            medical: 'Medical',
            zileSpeciale: 'Special Days',
            alteConcedii: 'Other types of',
            zileConcediu: 'Holidays',
            ramase: 'Left',
            evaluari: 'Evaluations',
            data: 'Date',
            evaluatori: 'Evaluators',
            completare: 'Completion',
            punctaj: 'Points',
            angajeaza: 'Hire',
            datePersonale: 'Personal Data',
            dateAngajare: 'Employment Data',
            nume: 'Name',
            numeFamilie: 'Family name',
            adresaResedinta: 'Residence Address',
            categoriePermis: 'License Category',
            salariulPropus: 'Proposed salary',
            specializare: 'Specialization',
            documenteCandidat: 'Candidate documents',
            cv: 'CV',
            alteDocumente: 'Other Documents',
            generazaDocumenteAngajare: 'Generate Employment Documents',
            dataNastere: 'Date of Birth',
            dateIdentificare: 'Identification Data',
            cnp: 'CNP',
            serieCi: 'CI Series',
            dateContact: 'Contact Data',
            salarizare: 'Pay',
            salariuBrut: 'Gross salary',
            salariuLunarNet: 'Net Lunar Salary',
            documenteAngajare: 'Employment Documents',
            documenteResurseUmane: 'Human Resources Documents',
            cauta: 'Search',
            fisiere: 'Files',
            documenteEditabile: 'Editable Documents',
            documentePdf: 'PDF Documents',
            documenteJpg: 'JPG Documents',
            rezultateCautare: 'Search Results',
            inapoi: 'Back',
            creatLa: 'Created on',
            documenteHrInEvidenta: 'HR documents in evidence',
            documentNou: 'New Document',
            programLucru:'Work Schedule',
            adaugaProgram:'Add Schedule',
            monitorizareLive:'Live Monitoring',
            data:'Date',
            status:'Status',
            inactivAzi:'Inactive Today',
            candActiv:'Last Active Time',
            raportareIndividuala:'Individual Report',
            raportAngajat:'Employee Report',
            foaieColectiva:'Foaie Colectiva',
            templateuri:'Templates',
            adaugaDocument:'Add Document',
            creeazaDocument:'Create Document',
            salveaza:'Save'

        },


        monitorizare: {
            esteProductiva:'Is Productive',
            salveaza:'Save',
            sterge:'Delete',
            numeleProcesului:'Proccess Name',
            numeleProcesului32:'Proccess Name 32bits',
            aplicatie:'App',
            numeAplicatie:'App Name',
            adaugaAplicatie:'Add App',
            monitorizareAngajati: 'Employee Monitoring',
            statusul: 'Status',
            scor: 'Score',
            celeMaiFolosite: 'The most used',
            statut: 'Statute',
            departament: 'Departament',
            celeMaiFolosite: 'The most used',
            lucratori: 'Users',
            appProductivitate: 'Productive Applications',
            appNeproductivitate: 'Unproductive Applications',
            oraPornire: 'Start Time',
            timpProductiv: 'Productive Time',
            productivitate: 'Productivity',
            distributiaTimpului: 'Time Distribution',
            timpNeproductiv: 'Unproductive Time',
            timpMort: 'Dead Time',
            aplicatiiProductive: 'Productive Applications',
            aplicatiiNeproductive: 'Unproductive Applications',
            screenshots: 'Screenshots',
            baraProductivitate: 'Productivity Bar',
            folosireAplicatie: 'Application Usage',
            denumire: 'Name',
            timp: 'Time',
            raportareMonitorizareAngajati: 'Employee Monitoring Reporting',
            raportLunar: 'Monthly report',
            zileLucrate: 'Worked days',
            totalOre: 'Total hours',
            prodMedie: 'Average prod.',
            scorMediu: 'Average score',
            distributiaTimpului: 'Time Distribution',
            pauza: 'Break',
            dataStart:'Starting Date',
            dataSfarsit:'Ending Date',
            afisazaRaport:'Show Report',
            aplicatii:'Apps',
            ora:'Hour',
            eticheta:'Label',
            eticheteFolosite:'Labels Used',
            totalLucrat:'Total Worked',
            nuExistaDatePentruOra:'There are no registred data at this hour !',
          

        },


        financiar: {
            bilanturi: 'Balance sheets',
            bilanturiInregistrateInSistem: 'Balance sheets registered in the system',
            bilantFinanciar: 'Financial Balance Sheet',
            tipBilant: 'Balance sheet Type',
            tipEntitate: 'Entity Type',
            cifraDeAfaceri: 'Fiscal value',
            clienti: 'Clients',
            adaugaBilantNou: 'Add New Balance Sheet',
            inapoi: 'Back',
            bilanturiLength0: 'Currently you do not have any balance entered in the system. To feed the Financial Diagnosis section you need one, ideally several balance sheets. Click the button below to enter a new balance sheet in the Total Works system. ',
            informatiiBilant: 'Information about this balance sheet',
            tipBilant: 'Balance sheet Type',
            an: 'Year',
            denumire: 'Name',
            tipEntitate: 'Entity Type',
            bilantNouMesaj: 'You are about to initiate a data entry session from your balance sheet. Fill in the data above and press the save button. The process will take you through several steps in which you will receive instructions for entering the related values found in your balance sheet. ',
            adaugaBilant: 'Add Balance Sheet',
            valoareInceput: 'Start Value',
            valoareSfarsit: 'End Value',
            maiDeparte: 'Next Step',
            aiTerminat: 'You finished!',
            felicitariBilant: 'Congratulations! You have successfully completed the process of entering your annual balance sheet',
            apasaFinalizeaza: 'Click Finish to be taken to the dashboard of the Financial Diagnosis section, or click View Report to access a printable detailed report. ',
            finalizeaza: 'Complete',
            adaugaClienti: 'Add Clients',
            diagnosticFinanciar: 'Financial Diagnosis',
            bilantAnual: 'Anual Balance sheet',
            informatiiDespreBilant: 'Balance sheet information',
            clienti: 'Clients',
            exercitiuFinanciar: 'Financial Exercise',
            numarClienti: 'Number of Customers',
            nrFacturiSold: 'Nr. of Invoices Balance',
            totalSoldClienti: 'Total Customers Balance',
            editeazaClienti: 'Edit Clients',
            editeazaBilant: 'Edit Balance sheet',
            nuAvemClienti: 'You have no customers entered in the system for the year  ',
            adaugaClientNou: 'Add a new Client',
            numeClient: 'Client Name',
            facturi: 'Invoices',
            sold: 'Balance',
            salveaza: 'Save',
            soldTotal: 'Total Balance',
            nuAvemFacturi: 'We do not have any invoice in the system for this customer',
            adaugaFacturaNoua: 'Add a new invoice',
            nrFactura: 'Invoice nr',
            dataEmitere: 'Date of issue',
            dataIncasarii: 'Date of Collection',
            depasire: 'Exceed',
            valoareFactura: 'Invoice Value',
            factura: 'Invoice',
            serieFactura: 'Invoice Series/Nr.',
            valoareLei: 'Value Lei',
            introduClienti: 'Enter Customers or Modify customer data to benefit from Customer Analysis',
            adaugareClientMesaj: '',
            dateDespreClientMesaj: 'Add all invoices issued to this customer in the year ',
            dateDespreClientMesaj2: 'to benefit from Customer Analysis. The calculation for delayed invoices is made with a period of 30 working days.',
            dataScadenta: 'Due Date',
            situatieGenerala: 'General Situation',
            totalVenituri: 'Total Revenue',
            totalCheltuieli: 'Total expenses',
            totalProfit: 'Total Profit',
            situatie: 'Situation',
            solduriClienti: 'Customer Balances',
            solduriClientiMesaj: 'Trade receivables, advances for the purchase of goods of the nature of stocks and for the provision of services granted to suppliers and other assimilated accounts, in gross amounts. ',
            solduriFurnizori: 'Supplier Balances',
            solduriFurnizoriMesaj: 'Trade payables, advances received from customers and other similar accounts, in gross amounts.',
            analizaCashFlow: 'Cashflow Analysis',
            cheltuieliSiCosturi: 'Expenses and Costs',
            mesajAnalizaCashFlow: 'This analysis area focuses on the costs and expenses that are part of the profit and loss statement.',
            costuri: 'Costs',
            cheltuieli: 'Expenses',
            venituri: 'Revenue',
            fluxulDeNumerar: 'Cash flow',
            planificareSiPrognoza: 'Planning and Forecasting',
            mesajPrognoza: "This analysis area identifies the planned values and variations from them, as well as the planned performance per unit. The key performance indicators analyzed are 'Forecast Amounts' and 'Planned Amounts' ",
            planificare: 'Planning',
            previzionat: 'Predicted',
            analizaProfitPierdere: 'Profit/Loss Analysis',
            marjaComerciala: 'Commercial Margin',
            marja: 'Margin',
            calificativ: 'Mark',
            trend: 'Trend',
            crestere: 'Growth',
            scadere: 'Decrease',
            productiaExercitiului: 'Exercise Production',
            valoare: 'Value',
            valoareAdaugata: 'Added Value',
            excedentBrutDinExploatare: 'Gross Operating Surplus',
            rezultatDinExploatare: 'Result from Exploitation',
            rezultatulBrutAlExercitiului: 'Gross Exercise Result',
            rezultatulNetAlExercitiului: 'Net Exercise Outcome',
            rataRentabilitatiiEconomice: 'Economic Profitability Rate',
            tendintaRentabilitatiiEconomice: 'The trend of Economic Profitability',
            rataRentabilitatiiFinanciare: 'Financial Profitability Rate',
            tendintaRentabilitatiiFinanciare: 'Financial Profitability Trend',
            analizaVanzariSiClienti: 'Sales and Customer Analysis',
            top5Clienti: 'Top 5 Customers Are Displayed',
            afisazaTotiClientii: 'Show All Clients',
            numeClienti: 'Clients Names',
            analiza: 'Analyze',
            segmentare: 'Segmentation',
            analizaVanzarilorAditionale: 'Additional Sales and Profitability Analysis',
            rataProfituluiBrut: 'Gross Profit Rate',
            marjaNetaAProfitului: 'Net Profit Margin',
            analizaSiRaportareProiecte: 'Project Analysis and Reporting',
            top3Proiecte: 'Top 3 Projects Are Displayed',
            afisazaToateProiectele: 'Show All Projects',
            numeProiect: 'Project Name',
            profitabilitate: 'Profitability',
            totalOre: 'Total Hours',
            numeSarcina: 'Task Name',
            cheltuieli: 'Expenses',
            buget: 'Budget',
            profit: 'Profit',
            analizaAngajatilor: 'Employees Analysis',
            top3Angajati: 'Top 3 Employees Are Displayed',
            afisazaTotiAngajatii: 'Show All Employees',
            proiecte: 'Projects',
            rezolvat: 'Resolved',
            pretOra: 'Price/Hour',
            pretTotal: 'Total Price',
            proiect: 'Project',
            editeazaPlanificarea: 'Edit Planning',
            planificareVenituri: 'Revenue Planning',
            lei: 'lei',
            analizaSiRaportareStocuri: 'Stock Analysis and Reporting',
            analizaStocurilor: 'Stock Analysis',
            vitezaDeRotatieAStocurilor: 'Stock Rotation Speed',
            diagnostic: 'Diagnostic',
            analizaCashFlowText: `The positive cash flow (≥0) indicates that the liquid assets of a company are growing, allowing it to pay its debts, continue to invest in the business, return the money to shareholders, etc., ie the company is profitable (solvent). Negative cash flow (≤0) indicates that a company's liquid assets are declining and means that the firm is not profitable. Cash flow is used to assess the quality of a company's revenue, which can indicate whether the company is solvent or not.`,
            rataRentabilitatiiEconomiceText: `O valoare sub 5% exprima faptul ca firma nu este rentabila din punct de vedere economic. O valoare peste 7% exprima faptul ca firma este rentabila din punct de vedere economic`,
            tendintaRentabilitatiiEconomiceText: '',
            rataRentabilitatiiFinanciareText: `A value below 25% expresses the fact that the company is not profitable from a financial point of view. A value over 25% expresses the fact that the company is financially profitable`,
            tendintaRentabilitatiiFinanciareText: '',
            analizaClientilorText: `It helps the organization understand why customers are absorbed, migrating, or deciding to stay. you can identify key trends in customer wear and tear that can help develop effective programs Retention.​`,
            rataProfituluiBrutText: `Gross profit rate, calculated as a percentage ratio between the mass of gross profit and the costs invested in obtaining it or the volume of capital used. By calculating this ratio, the degree of profitability per product, economic unit, industrial branch or national economy is obtained. The rate of gross profit below 1% indicates an unstable situation. The gross profit rate between 1% and 15% indicates a stable situation. The gross profit rate above 15% may indicate a volatile situation.`,
            marjaProfituluiBrutText: `The net profit margin is a financial indicator of profitability, which shows us in percentages how profitable the total activity of a company is. It is a comparison between the profit remaining after tax and net sales and shows the profit remaining after all production and administration costs have been deducted from sales and the recognized profit tax. It is one of the best measures of a company's results, especially when combined with an assessment of how working capital is used. Usually, the indicator is analyzed in trend, from one period to another, but it can also be compared with the results obtained by competitors.`,
            solduriClientiText:`Increase of over 20% - does not collect its receivables WEAK, Increase of 19% - medium, Decrease of over 20% - collects its receivables - VERY GOOD`,
            solduriFurnizoriText:`Increase of over 20% - does not pay its debts - WEAK, Increase of 19% - MEDIUM, Decrease of over 20% - pays its debts - VERY GOOD`,
            analizaStocurilorText:`A stock analysis should be able to highlight the problems you have with stocks and give you solutions to fix those problems. Reducing the value of stocks, as well as optimizing processes, is a continuous activity in the company, an activity that must be done periodically with the ultimate goal of reducing stocks. The reduction of the value of stocks has direct and fast effects in the company's cash flow.`,
            vitezaDeRotatieAStocurilorText:`It is an indicator that tells you how many times the stock you have in a period of time is sold. The BBB product has a rotation speed equal to 1 means that, this month, you sold an amount equal to the average stock this month (average speed). A speed of 2 or 3 shows that you have sold a quantity two or three times higher than the average stock (good speed) The subunit speed (for example 0.3) indicates that only a fraction of your stock has been sold: CCC you only sold a third of what you had (poor speed)`,
            raportGeneral:'General Report',
            nuExistaSuficienteBilanturi:'There are no sufficient data in the system, please add a minumum of balance sheets for 2 years.',
            fataDeAnulTrecut:'Compared to last year',
            slab:'Low',
            mediu:'Medium',
            foarteBine:'Very Good',
            diagnostic:'Diagnostic',
            negativ:'Negative',
            pozitiv:'Positive',
            situatie:'Situation',
            fluxPozitiv:'Positive Cash Flow',
            fluxNegativ:'Negative Cash Flow',
            buna:'Good',
            inSistem:'in the System',
            companiaEInPierdere:'The company is at a loss',
            companiaEInProfitMediu:'The company has an average increase in profit',
            companiaEInProfit:'The company is profitable. You are on a good direction',
            rea:'Bad',
            viteza:'Speed',
            loial:'Loial',
            nou:'New',
            pierdut:'Lost',
            bunPlatnic:'Good Payer',
            rauPlatnic:'Bad Payer',
            importaBilant:'Import Balance',
            downloadTemplateBilant:'Download Balance Template',
            download:'Download',
            venituriSiPreviziuni:'Incomes and Previzions',
            cheltuieliSiPreviziuni:'Expenses and Previzions',
            nuExistSuficienteBilanturi:'There are not enough balances, please add at least 2 balances in the system.',
            downloadTemplateClienti:'Download Clients Template',
            importaClienti:'Import Clients'
            

        },


        economic:{
            economic:'Economic',
            selecteazaProiect:'Select a project to get access to the expenses zone',
            buget:'Budget',
            cheltuieli:'Expenses',
            bugetTotal:'Total Budget',
            cheltuieliTotal:'Total Expenses',
            profit:'Profit',
            sarciniCuCheltuieli:'Tasks with Expenses',
            utlilizatoriCuCheltuieli:'Users with Expenses',
            afisazaDupa:'Show By',
            sumaCheltuieli:'The Amount of Expenses',
            perioada:'Period',
            liniiBuget:'Budget Lines',
            liniiCheltuieli:'Expenses Lines',
            alerte:'Alerts',
            operatiuni:'Operations',
            denumireBuget:'Budget Name',
            valoareBuget:'Budget Value',
            modificat:'Modified',
            denumireProdusServiciu:'Product/Service Name',
            cantitate:'Quantity',
            pret:'Price',
            tva:'TVA',
            totalPlusTva:'Total + TVA',
            denumireCheltuiala:'Expense Name',
            valoareCheltuiala:'Expense Value',
            alocatLaBuget:'Allocated to the Budget',
            acestUtilizatorNuAreCheltuieli:'This user does not have expenses for this project',
            etapa:'Stage',
            perioada:'Period',
            atasamente:'Attachments',
            direct:'Direct',
            bugetCuPersonal:'Staff Budget',
            cheltuialaCuPersonal:'Staff Expenses',
            bugetTask:'Task Budget',
            bugetAlocatCheltuielii:'Budget Allocated to the Expense',
            liniiChletuieli:'Expenses Lines',
            valoare:'Value'

        },


        documenteProiecte:{
            managementDocumente:'Documents Management',
            proiecte:'Projects',
            documente:'Documents',
            veziToateDocumentele:'Show All Documents',
            veziMaiPutin:'Show Less'


        },

        managementUtilizatori:{
            dateSalvate:'User data saved ',
            managementUtilizatori:'User Management',
            lucratoriInterni:'Internal Workers',
            oras:'City',
            salariuBrut:'Gross Salary',
            utilizatorNou:'New User',
            lucratoriExterni:'External Workers',
            companie:'Company',
            costPeOra:'Cost / Hour',
            contulMeu:'Contul Meu',
            datePersonale:'Personal Data',
            nume:'Name',
            numeIntreg:'Full Name',
            cnp:'CNP',
            adresa:'Address',
            telefon:'Phone',
            email:'E-Mail',
            adresaEmail:'E-Mail Address',
            dateProfesionale:'Proffessional Data',
            departament:'Department',
            firma:'Firm',
            functie:'Function',
            manager:'Manager',
            da:'Yes',
            nu:'No',
            salariu:'Salary',
            program:'Time Schedule',
            salveaza:'Save',
            info:'Info',
            oParolaMaiPuternica:'A stronger password has more than 6 characters and contains small letters , big letters , numbers and at least a sign (@#$%&)',
            stergeUtilizator:'Do you really want to delete this user ?',
            utilizatoriiNuPotFiRecuperati:'Once deleted the user cannot be restored. ',
            stergeDepartament:'Do you really want to delete this department ?',
            adaugaDepartament:'Add Department',
            membruNou:'New Member',
            managementDepartamente:'Department Management',
            detaliiProgram:'Time Schedule Details',
            creeazaProgramNou:'Create a New Time Schedule',
            denumireProgram:'Schedule Name',
            nuExistaProgram:'There is no time schedule created. To create a new time schedule please press the "Create a New Time Schedule" Button',
            pauza:'Break',
            oraIncepere:'Starting Hour',
            oraFinalizare:'Ending Hour',
            verifyCnp:`The SSN is not correct.`,
            verifyTel:'The phone number is not correct.',
            verifySerie:'The serial number is not correct.'
            
        },





        proiecte: {
            nrZileConcediu:'Nr. Vacation Days',
            permisConducere:"Driver's Licence",

            perioadaProiectului:'Project Period',
            proiectNou:'New Project',
            dezArhiveazaProiect:'Unpacking the project ?',
            proiectulDezarhivat:'The unpacked project will be found in the projects section.',
            arhivaProiecte:'Archived Projects',
            accessFinanciar:'Financial Access',
            alertView:'No Access!',
            alertViewMessage:'You cannot access this page, press ok to get back to Home !',

            tipIntroducere:'Type of Introduction',
            cheltuialaIndividuala:'Individual Expense',
            bugetIndividual:'Individual Budget',
            bugetDefalcat:'Broken Down Budget',
            cheltuialaDefalcata:'Broken Down Expense',
            valoare:'Value',
            denumireCheltuiala:'Cost Name',
            etapaProiectului:'Project Stage',
            definesteCheltuielile:'Define the expenses for the project budget ',
            creeazaProiectNou:'Create New Project',
            archiveProject: 'Are you archiving the project?',
            archiveProjectMessage: 'Archived projects can be accessed at any time from the Archives area found in the menu. ',
            deleteProject: 'Do you want to permanently delete the project?',
            deleteProjectMessage: 'Deleted projects can no longer be accessed. Consider the Archiving function',
            yes: 'Yes',
            no: 'No',
            ok: 'Ok',
            dateStart: 'Start date',
            dateFinish: 'End Date',
            projectManagement: 'Project Management',
            viewDetails: 'View details',
            complete: 'Complete',
            department: 'Department',
            taskDelay: 'Reason for delaying task',
            taskDelay: 'Reason for delay task here',
            finalize: 'Complete',
            taskDelete: 'Do you want to delete the selected task?',
            deleteTaskMessage: 'This function is irreversible and the task cannot be recovered! ',
            dateMsgAlert: 'The start date cannot be longer than the end date!',

            informatiiProiect: {
                titlu: 'Title',
                deLa: 'From',
                panaLa: 'Up to',
                descriere: 'Description',
                upload: 'Upload Document',
                dataDoc: 'Upload Date',
                stergeDoc: 'Delete Document'
            },

            etapeProiect: {
                titluInsertDialog: 'Add Stage',
                denumire: 'Stage Name',
                dela: 'From',
                panala: 'Until',
                responsabil: 'Here select the person in charge of the stage',
                addEtapa: 'Add a Stage',
                addTask: 'Add a Task',
                markComplete: 'Mark Completed',
                completat: 'Complete',
                selectDate: 'Select Date',
                numeTask: 'New Date',
                atribuitLui: 'Assigned to',
                deLaOra: 'From',
                panaLaOra: 'Until',
                descriereTask: 'Description',
                editeazaNumeSiDescriere: 'Edit name & description',
                numeEtapa: 'Name',
                deleteEtapa: 'Are you sure you want to delete the stage',
                subTask: 'Add a new subtask',
                timpEstimat: 'Estimated working time',
                data: 'Date',
                ore: 'Hours',
                minute: 'Minutes',
                zileCumulate: 'Cumulative Days',
                selecteazaUser: 'Select User',
                documenteTask: 'Task Documents',
                documenteEtape: 'Stage Documents',

            },
            nameTask: 'Click here and name this task ',
            name: 'Name',
            responsable: 'Responsible',
            selectUser: 'Select User',
            date: 'Date',
            budget: 'Budget',
            budgetName: 'Budget Name',
            budgetValue: 'Budget Value',
            operations: 'Operations',
            total: 'Total',
            spendings: 'Expenses',
            spendingName: 'Expense Name',
            spendingValue: 'Expense Value',
            description: 'Description',
            taskDetali: 'More details about the task',
            addDescription: 'Add a description',
            delays: 'Delays',
            whyDelayedTask: 'Why is the task delayed?',
            addAttachment: 'Add attachment',
            save: 'Save',
            delete: 'Delete',
            spendingManagement: 'Expense management',
            typeSelect: 'Select the Type',
            spendingType: 'Expense Type',
            addType: 'Introduction type',
            denumire: 'Name',
            quantity: 'Quantity',
            price: 'Price',
            tvaIncl: 'Incl. TVA',
            tva: 'TVA',
            valTva: 'TVA Val.',
            denumireProdus: 'Product Name',
            value: 'Value',
            sum: 'Sum',
            alocaBuget: 'Allocate Budget',
            bugetAlocat: 'Allocated Budget',
            addNewProduct: 'Add new Product',
            worker: 'User',
            hours: 'Hours',
            hour: 'Hour',
            addNewWorker: 'Add new User',
            selectUser: 'Select User',
            budgetManagement: 'Administreaza Buget',
            budgetType: 'Budget Type',
            viewMode: 'View Mode',
            denumireTask: 'Task Name',
            select: 'Select',
            clickNewTask: 'Click here to create a new task',
            welcomeToIdeaView: 'Welcome to viewing mode',
            idea: 'idea',
            ideaViewMessage: `of your project. This mode is designed to help you quickly build the idea of your project in a visual way. Below you will find the stages of your project created in the previous steps. Hover your mouse over a project stage to add tasks`,
            stage: 'Stage',
            duration: 'Duration',
            gradDeCompletare: 'Degree of completion',
            taskNumber: 'Number of tasks',
            selectTaskToExpand: 'Select one of the above project stages to access its tasks and subtasks',
            noTaskAdded: 'You have not added any tasks to your project. To continue planning your project, select the stage you want to start with and add tasks.',
            completedAt: 'Completed at',
            subtasksNumber: 'Number of Subtasks',
            subtasksTermenDepasit: 'Overdue subtasks',
            subtaskTermenDepasit: 'Overdue subtask',
            manageTask: 'Manage Task',
            modifyInteractiveData: 'Edit Data Interactively',
            newTask: 'New Task',
            noTaskInEtapa: ' You have no task at this stage. Add a task from the button below.',
            dateDespreNoulProiect: 'Some data about your new project',
            denumireProiect: 'Project Name',
            exPoianaMarului: 'Ex: Pension Poiana Marului',
            projectDescription: 'Project Description',
            projectDescriptionPlaceHolder: 'A short description of the project',
            beneficiarProiect: 'Project Beneficiary',
            beneficiarProiectPlaceHolder: 'Ex: SC. COMPANYNAME S.R.L',
            cui: 'CUI',
            dataInceputProiect: 'Project Start Date',
            dataSfarsitProiect: 'Project End Date',
            step2Project: 'Step 2: Define Users',
            utilizatoriProiecte: 'Defines the users working on this project',
            selectUsers: 'Select Users',
            newUser: 'New User',
            step3Project: 'Step 3: Define the Project Stages',
            stepBack: 'Previous step',
            userName: 'User Name',
            departamentIntern: 'Internal Department ',
            companieExterna: 'External Company',
            datePersonale: 'Personal Data',
            cnp: 'CNP',
            adresa: 'Address',
            oras: 'City',
            telefon: 'Phone Number',
            email: 'E-mail',
            adresaEmail: 'E-mail Address',
            password: 'Password',
            reapeatPassword: 'Repeat Password',
            dateServiciu: 'Service Data',
            esteManager: 'Manager',
            selectDepartment: 'Select Department',
            firma: 'Company',
            functie: 'Function',
            salariu: 'Salary',
            salariuBrut: 'Gross salary',
            costOra: 'Cost / Hour',
            accesDepartamente: 'Department Access',
            cV: 'Curriculum Vitae',
            fisaPostului: 'Job description',
            program: 'Schedule',
            alertDataEtapa: 'The start date of the stage cannot be longer than the end date!',
            alertDataEtapaSfarsit: 'The end date of the stage cannot be shorter than the start date!',
            creeazaEtape: 'Create the project stages',
            taskuriDepasite: 'Overdue tasks',
            taskDepasit: 'Overdue task',
            perioadaProiectului: 'Project period',
            denumireEtapa: 'Stage Name',
            denumireEtapaPlaceholder: 'Name of the first stage',
            selecteazaResponsabilEtapa: 'Select responsible user',
            descriereEtapa: 'Stage Description',
            dateEtapa: 'Stage Data',
            salveazaEtapa: 'Save Stage',
            creeazaEtape: 'Create the project stages',
            etapa: 'Stage',
            addEtapa: 'Add Stage',
            step4Projects: 'Step 4: Define Budget',
            selectEtapaProiect: 'Select the project stage',
            spreTaskuri: 'Introduce tasks',


            numeProiect: 'Project Name',
            numeUser: 'User Name',
            legenda: 'Legend',
            detaliiProiect: 'Project Details',
            segmentButtons: {
                informatii: 'Information',
                etape: 'Stages',
                taskuri: 'Tasks',
                drepturi: 'User Management',
                costuri: 'Project Budget',
                documente: 'Project Documents',
                rapoarte: 'Reports'
            },
            status: {
                finalizata: 'Completed',
                blocat: 'Delayed',
                inlucru: 'Working',
                inviitor: 'Future'
            },





            rapoarteProiect: {
                situatiiGenerale: 'General Situations',
                situatiiEtape: 'Stages Situations',
                nrTaskuriCompletateDepasite: 'Nr. outdated completed tasks',
                nrTaskuriCompletateInTermen: 'Nr. tasks completed on time',
                nrTaskuriDeschise: 'Nr. open tasks',
                nrTaskuriDeschiseDepasite: 'Nr. outdated open tasks',
                nrTaskuriFinalizate: 'Nr. completed tasks',
                nrTotalTaskuri: 'Nr. of tasks',
                nrUtilizatori: 'Nr. Users',
                ordoneazaDupa: 'Order by',

                calificativMedie: 'Average rating',
                medieAvansPerTask: 'Average advance/task',
                medieDepasirePerTask: 'Average exceed/task',
                medieGenerala: 'General average',
                nrTaskuriAvans: 'Nr. advance tasks',
                nrTaskuriDepasite: 'Nr. outdated tasks',
                nrTaskuriTermen: 'Nr. term tasks',
                nrTotalTaskuri: 'Nr. tasks',
                totalOreAvans: 'Total advance hours',
                totalOreDepasire: 'Total hours exceeded',
                totalOreCumulateTaskuri: 'Total hours accumulated tasks',
                totalOreDiferentaCompletare: 'Total overtime',
                totalOreAvansCompletare: 'Total hours of completion',
                pctDepasire: 'Percentage exceeding tasks ',
                pctAvans: 'Percentage advance tasks',


                numeUser: 'User Name',
                numeProiect: 'Project Name',
                deLa: 'From',
                panaLa: 'Until',
                numeTask: 'Task Name',
                durataOre: 'Duration'

            }
        },


        alertDate: {
            subTask: 'The selected date does not fall within the period to which it belongs!',
            etapa: 'The selected date does not fall within the project period to which it belongs or the start date is lower than the previous stage!',
            task: 'The selected date does not fall within the stage to which it belongs!',
            document: 'Are you sure you want to delete the document?'
        },
        clienti: {
            nume: 'Name',
            adresa: 'Address',
            oras: 'City',
            nationalitate: 'Nationality',
            limba: 'Language',
            educatie: 'Education',
            clasaSociala: 'Clasa Sociala',
            sex: 'Gender',
            religie: 'Religion',
            rasa: 'Race',
            nrMembriiFamilie: 'Number of Family Members',
            ocupatie: 'Ocupation',
            stilViata: 'Lifestyle',
            venit: 'Income',
            note: 'Notes',
        },




        administrare: {
            mesagerie: 'Messaging',

        },
        mesagerie: {
            trimiteUtilizatori: 'Send emails to users',
            trimiteSumar: 'Send the summary of the day'
        },
        chestionareCategorii: {
            descriere: 'Questionnaire description',
            cumArataRezultatele: 'What the results look like',
            numarulDeIntrebari: 'Number of questions',
            timpCompletare: 'Estimated time',
            templateChestionare: 'Template Categories',
            chestionareleMele: 'My Evaluation',
            adaugaEval: 'Create Evaluation',
            anuleazaEval: 'Cancel Evaluation',
            addEval: 'Add Evaluation',
            chestionareRealizate: 'Evaluation Performed',
            evalNoua: 'Evaluare noua',
            evalInCurs: 'Evaluari in curs',
            evalCompletate: 'Evaluari Completate',
            adaugaCompletatori: 'Add Evaluator',
            adaugaIntrebare: 'To add a question, drag it over this rectangle',
            intrebari: 'Questions',
            intrebare: 'Question',
            categoriileMele: 'My Evaluations',
            raspunsuriPredefinite: 'Predefined Answers'

        },

        financiarContabil: {
            selecteazaAnul: 'Select year',
            selecteazaLuna: 'Select month',
            selecteazaZi: 'Select day',
            luna: 'Munth',
            nume: 'Name',
            anul: 'Year',
            rau: 'Bad',
            slab: 'Weak',
            bun: 'Good',
            foarteBun: 'Very good',
            prognoza: 'Revenues and forecasts',
            analizaUtilizatori: 'User analysis',
            analizaFinanciara: 'Financial analysis and reporting',
            analizaCashFlow: 'Cash flow analysis',
            analizaProiecte: 'Project analysis',
            selecteazaIndicator: 'Select Indicator',
            valoare: 'Value',
            balante: 'Trial balances',
            bilanturi: 'Balance Sheets',
            cont: 'Account',
            tip: 'Type',
            client: 'Client',
            variatie: 'Variation',
            evolutie: 'Evolution',
            analizaDeVanzariSiClienti: 'SALES AND CUSTOMER ANALYSIS',
            evolutiaSolduluiPeClient: 'THE EVOLUTION OF THE BALANCE PER CUSTOMER',
            clientiCastigatiLunar: 'NEW CUSTOMERS WON MONTHLY',
            lunaCurenta: 'THIS MONTH',
            lunaAnterioara: 'PREVIOUS MONTH',
            acum2Luni: '2 MONTHS AGO',
            clientiPierduti: 'LOST CUSTOMERS',
            nuExista: 'NO DATA',
            clientiCastigati: 'CLIENTS WON',
            clientiLoiali: 'LOYAL CUSTOMERS',
            clientiActivi: 'ACTIVE CUSTOMERS',
            comparatieRealizatPlanificat: 'COMPARISON PERFORMED - PLANNED',
            venituri: 'Income',
            cheltuieli: 'Expenses',
            venituriPlanificate: 'Planned Income',
            cheltuieliPlanificate: 'Planned Expenses',
            facturi: 'INVOICES',
            document: 'Document',
            termen: 'Deadline',
            total: 'Total',
            facturiNeincasate: 'Uncollected invoices',
            facturiInTermen: 'Invoices In Term',
            valoareAnterioara: 'Previous Value',
            valoareCurenta: 'Current Value',
            initiala: 'Initial',
            finala: 'Final',
            anticipata: 'Anticipated',
            totalOreCumulateTaskuri: 'Total hours accumulated tasks',
            totalOreDepasiteCompletare: 'Total hours completed',
            totalOreAvansCompletare: 'Total hours of completion',
            procentajDepasire: 'Percentage exceeded',
            procentajAvans: 'Percentage Advance',
            durata: 'Time',
            etape: 'Stages',
            taskuri: 'Tasks',
            pozitiva: 'Positive',
            negativa: 'Negative',
            stationara: 'Stationary',
            alertExistaBilant: 'There is already a balance for the selected year, if you want to continue the file will be overwritten!',
            importaBilant: 'Import Balance Sheet',
            importaBalanta: 'Import Trial balance',
            importaClienti: 'Import Clients',
            istoricIndicatoriFinanciari: 'History of financial indicators',
            balanteSiBilanturi: 'Trial balances and balance sheets',
            planificare: 'Planning',
            selecteazaFisier: 'Select File',
            succesImportBilant: 'Successful balance sheet import',
            solduriClienti: 'Customer balances',
            debit: 'Debit',
            credit: 'Credit',
            solduriFurnizori: 'Supplier Balances',
            utilizatorulTerminaTaskurileInainteDeTermen: 'The user completes most tasks ahead of time by approx',
            utilizatorulDepasesteTaskurile: 'The user usually exceeds the tasks by approx',
            fisaClientului: 'Customer file',
            nrFacturi: 'Invoice nr.',
            totalDeIncasat: 'Total receivable',
            nuSePoateCalcula: 'It cannot be calculated',
            criteriul: 'Criteria',
            clasificare: 'Classification',
            anulAnterior: 'Previous Year',
            segmentareClientiInFunctieDeCaracteristici: 'CUSTOMER SEGMENTATION ACCORDING TO CHARACTERISTICS',
            educatie: 'EDUCATION',
            ocupatia: 'Ocupation',
            clasaSociala: 'Social Class',
            limba: 'LANGUAGE',
            nationalitate: 'NATIONALITY',
            numarMembriiFamilie: 'NUMBER OF FAMILY MEMBERS',
            ocupatie: 'OCUPATION',
            rasa: 'RACE',
            religie: 'RELIGION',
            sex: 'GENDER',
            masculin: 'Male',
            feminin: 'Female',
            stilDeViata: 'LIFESTYLE',
            venit: 'INCOME',
            trendPastrareClientiTrimestru: 'TREND TO KEEP CUSTOMERS QUARTER',
            trimestrul: 'Quarter'


        },




        noData: 'Unplanned',




        date: 'en',







        organigrama: {
            nume: 'Name',
            email: 'E-mail',
            telefon: 'Phone Number',
            adresa: 'Address',
            sef: 'Boss',
            oras: 'City',
            fisa: 'Job description',
            veziFisa: 'Open File',
            adaugaFisa: 'Add Sheet',
            cv: 'Curriculum Vitae',
            adaugaCv: 'Add CV',
            veziCv: 'Open CV',
            programLucru: 'Work Schedule',
            inceputProg: 'Program Start',
            sfarsitProg: 'Program End',
            cost: 'Cost/min',
            dateleFirmei: 'Company Data',
            cui: 'CUI',
            tip: 'Type',
            nrInregistrare: 'Nr. commerce register',
            tva: 'TVA',
            tipMoneda: 'Currency Type'
        },

        zileleSapt: {
            luni: 'Monday',
            marti: 'Tuesday',
            miercuri: 'Wednesday',
            joi: 'Thursday',
            vineri: 'Friday',
            sambata: 'Saturday',
            duminica: 'Sunday'
        },
        luni: {
            ianuarie: 'January',
            februarie: 'February',
            martie: 'March',
            aprilie: 'April',
            mai: 'May',
            iunie: 'June',
            iulie: 'July',
            august: 'August',
            septembrie: 'September',
            octombrie: 'Octomber',
            noiembrie: 'November',
            decembrie: 'December'
        },
        pontaj: {
            oreLucrate: 'Hours worked',
            concedii: 'Vacations',
            contractDeMunca: 'Employment contract',
            protectiaMuncii: 'Employee protection',
            dosareDeSanatate: 'Health files',
            studii: 'Studies',
            cv: 'CV',
            rude: 'Kin (Parents, Children)',
            pasiuni: 'Passions',
            cursuri: 'Courses',
            evaluareProfesionala: 'Professional Evaluation',
            angajati: 'Employees',
            saptamana: 'A week',
            luna: 'A month',
            ansamblu: 'Ensemble',
            treiLuni: '3 Months'
        },

        bugete: {
            nume: 'Name',
            proiecte: 'Projects',
            contabilitate: 'Accountancy',
            intern: 'Intern',
            addBudget: 'Add Budget',
            budgets: 'Budgets',
            costs: 'Expenses',
            addCost: 'Add expenses',
            adaugatEditat: 'Added/Edited by',
            adaugatLa: 'Added to date',
            angajatiAlocati: 'Employees assigned to the project',
            nrTaskuri: 'Assigned user/project tasks',
            nrTaskuriT: 'User assigned tasks'
        },




    }





}  // end class